import I18n from 'i18n-js';
I18n.translations || (I18n.translations = {});
I18n.translations["en"] = I18n.extend((I18n.translations["en"] || {}), {
  "activerecord": {
    "attributes": {
      "address": {
        "city": "City",
        "line1": "Address 1",
        "line2": "Address 2",
        "postal_code": "Zip/Postal Code",
        "province": "State/Province"
      },
      "company": {
        "contact_name": "Contact name",
        "create_company": "Create company",
        "new": "New Company",
        "select_organization": "Select Organization",
        "tax_id": "Tax ID"
      },
      "division": {
        "description": "Division Name",
        "division_fee": "Division Fee $",
        "fees_for_all_classes": "Single fee for all Classes $"
      },
      "equine_association": {
        "name": "Organization",
        "number": "Membership Number"
      },
      "equine_association_fee": {
        "ec_temporary_horse_fee": "EC Temporary Horse fee",
        "ec_temporary_owner_sport_fee": "EC Temporary Owner Sport fee",
        "ec_temporary_rider_sport_fee": "EC Temporary Rider Sport fee",
        "ec_upgrade_bronze_to_gold_fee": "EC Upgrade Bronze to Gold fee",
        "ec_upgrade_bronze_to_silver_fee": "EC Upgrade Bronze to Silver fee",
        "ec_upgrade_silver_to_gold_fee": "EC Upgrade Silver to Gold fee",
        "usef_3_yr_senior_junior_active_membership": "USEF 3 Yr. Senior/Junior Active Membership",
        "usef_annual_horse_passport": "USEF Annual Horse Passport",
        "usef_competition_fee": "USEF Competition Fee",
        "usef_fei_horse_passport": "FEI Horse Passport",
        "usef_junior_active_membership": "USEF Junior Active Membership",
        "usef_lifetime_horse_passport": "USEF Lifetime Horse Passport",
        "usef_lifetime_membership": "USEF Lifetime Membership",
        "usef_national_horse_passport": "USEF National Horse Passport",
        "usef_national_to_fei_horse_passport_upgrade": "USEF National to FEI Horse Passport Upgrade",
        "usef_senior_active_membership": "USEF Senior Active Membership"
      },
      "horse": {
        "age": "Age",
        "barn": "Barn",
        "blob": "Vaccination Certificate",
        "breed": "Breed",
        "color": "Color",
        "dam": "Dam",
        "enter_valid_number": " number is not on the sanctioning body database. Please enter a valid number.",
        "first": "1st",
        "green": "Green Status",
        "height": "Height (Hands)",
        "open": "Open",
        "passport_verified": "Passport Info Verified",
        "pony_size": "%{size} Pony",
        "second": "2nd",
        "sex": "Sex",
        "sire": "Sire",
        "sire_dam": "Sire's Dam",
        "size": "Size",
        "thoroughbred_verified": "Thoroughbred Verified"
      },
      "individual_show": {
        "company_name": "Show Producer Company",
        "company_website": "Show Producer Website"
      },
      "officiations": {
        "cost": "Cost before tax $",
        "tax": "Tax $"
      },
      "services": {
        "campsite_warning": "You cannot change a stall order once stalls",
        "cost": "Cost before tax $",
        "services_order": "Services Order",
        "stall_warning": "You cannot change a campsite order once campsites",
        "tax": "Tax",
        "total_cost": "Total Cost",
        "unit_cost": "Unit Cost",
        "warning": " have been assigned. For assistance, please contact the show at "
      },
      "user": {
        "allow_emailing": "Allow Emailing",
        "allow_texting": "Allow Texting",
        "date_of_birth": "Date of Birth",
        "email": "Email",
        "first_name": "First Name",
        "last_name": "Last Name",
        "mobile": "Mobile",
        "new_person": "New Person",
        "password": "Password",
        "password_confirmation": "Password Confirmation",
        "phone": "Phone",
        "sponsored_by": "Sponsored By: "
      }
    },
    "errors": {
      "messages": {
        "record_invalid": "Validation failed: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Cannot delete record because dependent %{record} exist",
          "has_one": "Cannot delete record because a dependent %{record} exists"
        }
      }
    }
  },
  "add": "Add",
  "all": "All",
  "are_you_sure": "Are you sure?",
  "at": "@",
  "back_button_label": "Back",
  "button": {
    "circuit_results": "butt-circuit-results.jpg",
    "exhibitor_entries": "butt-entries-service-orders.png",
    "exhibitor_entries_hint": "This lets you view past or pending show entries or service orders and create new ones",
    "exhibitor_horses": "butt-horses.png",
    "exhibitor_horses_hint": "This lets you add edit or delete horses that you register in shows",
    "exhibitor_how_to_use": "butt-how-to-use-esm.png",
    "exhibitor_myesm": "butt-myesm-rt-show.png",
    "exhibitor_people": "butt-people.png",
    "exhibitor_people_hint": "This lets you add, edit or delete riders, owners and trainers that you use for your show registrations",
    "exhibitor_reports": "butt-reports.png",
    "exhibitor_reports_hint": "This lets you view prizes, points and placings for individual shows or circuits",
    "home_new_account": "butt-sn-up-crt-acct.jpg",
    "home_new_account_hint": "Use this button to create an ESM account that will submit show registrations",
    "home_search_account": "butt-searchaccount.png",
    "home_search_account_hint": "Use this button to search accounts to see if you already have one",
    "home_show_results": "ShowResults.png",
    "home_show_results_hint": "Use this button to show competition results",
    "home_sign_in": "butt-sign-in.jpg",
    "home_sign_in_hint": "Sign in to ESM"
  },
  "casl": {
    "text": "<h1>CASL Consent Form</h1> <p>EQUESTRIAN SHOW MANAGER INC.</p> <p>COMMERCIAL ELECTRONIC MESSAGES CONSENT</p> <p>Canada’s anti-spam legislation requires us to have your consent before sending you communications about equestrian events and our services.</p> <p>Equestrian Show Manager Inc. provides the up-to-date services needed by equestrians at all kinds of equestrian events. Access to show statistics, results and prizes, show events and upcoming shows, as well as information about products and services that may be of interest to equestrians, are contained on our websites at www.esm.horse and www.myesm.horse. Just look up the events you are interested in for full information.</p>\n"
  },
  "class": "Class",
  "comments": "Comments",
  "company_label": "Company",
  "company_name": "Company Name",
  "currency_symbol": "$",
  "date": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "formats": {
      "default": "%d-%m-%Y",
      "long": "%B %d, %Y",
      "short": "%d %b"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "order": [
      "year",
      "month",
      "day"
    ],
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %I:%M:%S %p %Z",
        "long": "%B %d, %Y %I:%M %p",
        "short": "%d %b %I:%M %p"
      },
      "pm": "pm"
    }
  },
  "date_placeholder": "yyyy-mm-dd",
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "about 1 hour",
        "other": "about %{count} hours"
      },
      "about_x_months": {
        "one": "about 1 month",
        "other": "about %{count} months"
      },
      "about_x_years": {
        "one": "about 1 year",
        "other": "about %{count} years"
      },
      "almost_x_years": {
        "one": "almost 1 year",
        "other": "almost %{count} years"
      },
      "half_a_minute": "half a minute",
      "less_than_x_minutes": {
        "one": "less than a minute",
        "other": "less than %{count} minutes"
      },
      "less_than_x_seconds": {
        "one": "less than 1 second",
        "other": "less than %{count} seconds"
      },
      "over_x_years": {
        "one": "over 1 year",
        "other": "over %{count} years"
      },
      "x_days": {
        "one": "1 day",
        "other": "%{count} days"
      },
      "x_minutes": {
        "one": "1 minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "1 month",
        "other": "%{count} months"
      },
      "x_seconds": {
        "one": "1 second",
        "other": "%{count} seconds"
      }
    },
    "prompts": {
      "day": "Day",
      "hour": "Hour",
      "minute": "Minute",
      "month": "Month",
      "second": "Seconds",
      "year": "Year"
    }
  },
  "delete_button_label": "Delete",
  "devise": {
    "confirmations": {
      "confirmed": "Your account was successfully confirmed.",
      "send_instructions": "You will receive an email with instructions about how to confirm your account in a few minutes.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions about how to confirm your account in a few minutes."
    },
    "failure": {
      "already_authenticated": "You are already signed in.",
      "inactive": "Your account is not activated yet.",
      "invalid": "Invalid email or password.",
      "last_attempt": "You have one more attempt before your account will be locked.",
      "locked": "Your account is locked.",
      "not_found_in_database": "Invalid email or password.",
      "timeout": "Your session expired. Please sign in again to continue.",
      "unauthenticated": "You need to sign in or sign up before continuing.",
      "unconfirmed": "Before you can sign in and use your new account, you must confirm your email address."
    },
    "mailer": {
      "confirmation_instructions": {
        "subject": "Confirmation instructions"
      },
      "email_changed": {
        "subject": "Email Changed"
      },
      "password_change": {
        "subject": "Password Changed"
      },
      "reset_password_instructions": {
        "subject": "Reset password instructions"
      },
      "unlock_instructions": {
        "subject": "Unlock Instructions"
      }
    },
    "omniauth_callbacks": {
      "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
      "success": "Successfully authenticated from %{kind} account."
    },
    "passwords": {
      "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
      "send_instructions": "You will receive an email with instructions on how to reset your password in a few minutes.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
      "updated": "Your password was changed successfully. You are now signed in.",
      "updated_not_active": "Your password was changed successfully."
    },
    "registrations": {
      "destroyed": "Bye! Your account was successfully cancelled. We hope to see you again soon.",
      "signed_up": "Welcome! You have signed up successfully.",
      "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
      "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
      "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please open the link to activate your account.",
      "update_needs_confirmation": "You updated your account successfully, but we need to verify your new email address. Please check your email and click on the confirm link to finalize confirming your new email address.",
      "updated": "You updated your account successfully.",
      "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again."
    },
    "sessions": {
      "already_signed_out": "Signed out successfully.",
      "signed_in": "Signed in successfully.",
      "signed_out": "Signed out successfully."
    },
    "unlocks": {
      "send_instructions": "You will receive an email with instructions about how to unlock your account in a few minutes.",
      "send_paranoid_instructions": "If your account exists, you will receive an email with instructions about how to unlock it in a few minutes.",
      "unlocked": "Your account has been unlocked successfully. Please sign in to continue."
    }
  },
  "edit_button_label": "Edit",
  "email": "Email",
  "entry": {
    "age_with_colon": "Age:",
    "create_new_horse_entry": "Create a new horse entry",
    "create_new_services_entry": "Create a new services entry",
    "create_season_campsite_order": "Create a Season Campsite Order",
    "create_season_stall_order": "Create a Season Stall Order",
    "enter_show": "Enter in Show",
    "entered": "Entered",
    "entries_header": "Entries",
    "gold_membership": "Unless you are entering only classes with no equestrian association membership requirements, this show requires the horse owner have a gold membership with Equestrian Canada.  A Temporary Owner Fee will be charged.",
    "gold_membership_upgrade_fee": "Unless you are entering only classes with no equestrian association membership requirements, this show requires the horse owner have a gold membership with Equestrian Canada.  An upgrade Fee will be charged.",
    "green_status_with_colon": "Green Status:",
    "height_hands": "Height (Hands):",
    "horse_can_enter_only_one_show": "A Horse can only enter each show once. A horse can have as many riders as you want in each show.",
    "horse_has_invalid_fei_number": "This horse has an FEI number that does not validate with FEI.  Please check the number.",
    "horses_or_services": "Horses / Services",
    "modal_multi_header": "Select a show to pay your entries on",
    "modal_multi_paragraph": "Pay for show:",
    "modal_multi_select": "Select",
    "multi_payment_current_show": "Current Show",
    "multi_payment_header": "Pay Multiple Entries With Debit/Credit Online",
    "multi_payment_owing": "Net Owing",
    "multi_payment_pay_now": "Pay Now",
    "not_entered": "Not Entered",
    "owing": "Owing",
    "owner_with_colon": "Owner:",
    "pay_multi_message": "Entries highlighted in red are those which you have indicated you will pay online by credit card. To make a single payment for multiple entries, click the Pay multiple entries button and then choose the show you'd like to pick. Check the entries you'd like to pay and then pay with square.",
    "pay_multiple_button": "Pay Multiple Entries",
    "payee_tax_id": "Payee Tax ID:",
    "payee_with_colon": "Payee:",
    "payments_pay_cr_later": "Pay credit/debit later (Pay multiple entries at once)",
    "press_ok_for_registration": "Press OK to continue with this registration.",
    "refund": "Refund",
    "save_later": "Save for Later",
    "save_new_entry": "Save and Start New Entry",
    "season_campsites": "Season Campsites",
    "season_stalls": "Season Stalls",
    "services_must_ordered_seperately": "Services must be ordered separately",
    "show_or_circuit": "Show / Circuit",
    "size_with_colon": "Size:",
    "split": "Split",
    "square_multi_instruction_header": "If you want to pay now:",
    "square_multi_instruction_paragraph": "Enter your Card details below and then click the blue Pay button",
    "stall_warning": "You can only add services (including stalls) to an entry once you have entered it in the show. Press Edit beside the entry then go to Step 5, Stalls and Services. Then press Enter in Show to be able to add services.",
    "start_date": "Start Date",
    "thoroughbred": "Thoroughbred",
    "trainer_or_coach": "Trainer/Coach:",
    "trainer_with_colon": "Trainer:",
    "type_with_colon": "Type:",
    "upgrade_fee": "Unless you are entering only classes with no equestrian association membership requirements, this show requires the horse owner have a silver membership with Equestrian Canada.  An upgrade Fee will be charged.",
    "valid_horse_records_temp_horse": "Unless you are entering only classes with no equestrian association membership requirements, this show requires the horse have a valid Horse Recording # with Equestrian Canada.  A Temporary Horse Fee will be charged.",
    "valid_horse_records_temp_owner": "Unless you are entering only classes with no equestrian association membership requirements, this show requires the horse owner have a bronze membership with Equestrian Canada.  A Temporary Owner Fee will be charged.",
    "valid_horse_records_temp_owner_fee": "Unless you are entering only classes with no equestrian association membership requirements, this show requires the horse owner have a silver membership with Equestrian Canada.  A Temporary Owner Fee will be charged."
  },
  "equine_association": {
    "add": "Add Membership",
    "add_title": "Add all of the memberships for this person. These will be automatically transferred to your entries.",
    "associations": {
      "alberta": "Alberta Equestrian Federation",
      "british_columbia": "Horse Council of British Columbia",
      "cheval_quebec": "Cheval Québec",
      "island": "Island Horse Council",
      "manitoba": "Manitoba Horse Council",
      "new_brunswick": "New Brunswick Equestrian Federation",
      "newfoundland": "Newfoundland and Labrador Equestrian Association",
      "nova_scotia": "Nova Scotia Equestrian Federation",
      "ontario_equestrian": "Ontario Equestrian",
      "ontario_hunter": "Ontario Hunter Jumper Association",
      "saskatchewan": "Saskatchewan Horse Federation",
      "trillium": "Trillium Hunter Jumper Association",
      "yukon": "Equine Association of Yukon"
    },
    "ec": "Equestrian Canada",
    "error_name_number": "Name Number Combination Already In Use",
    "fei": "Fédération Équestre Internationale",
    "foreign": "Foreign",
    "header": "Equine Association Membership",
    "remove": "Remove Membership",
    "select": "Select Organization",
    "thoroughbred_incentive": "Thoroughbred Incentive Program",
    "usef": "United States Equestrian Federation",
    "ushja": "United States Hunter Jumper Association"
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "must be accepted",
      "already_confirmed": "was already confirmed, please try signing in",
      "blank": "can't be blank",
      "confirmation": "doesn't match %{attribute}",
      "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
      "empty": "can't be empty",
      "equal_to": "must be equal to %{count}",
      "even": "must be even",
      "exclusion": "is reserved",
      "expired": "has expired, please request a new one",
      "greater_than": "must be greater than %{count}",
      "greater_than_or_equal_to": "must be greater than or equal to %{count}",
      "improbable_phone": "is an invalid number",
      "in": "must be in %{count}",
      "inclusion": "is not included in the list",
      "invalid": "is invalid",
      "less_than": "must be less than %{count}",
      "less_than_or_equal_to": "must be less than or equal to %{count}",
      "model_invalid": "Validation failed: %{errors}",
      "not_a_number": "is not a number",
      "not_an_integer": "must be an integer",
      "not_found": "not found",
      "not_locked": "was not locked",
      "not_saved": {
        "one": "1 error prohibited this %{resource} from being saved:",
        "other": "%{count} errors prohibited this %{resource} from being saved:"
      },
      "odd": "must be odd",
      "other_than": "must be other than %{count}",
      "password_too_long": "is too long",
      "present": "must be blank",
      "required": "must exist",
      "taken": "has already been taken",
      "too_long": {
        "one": "is too long (maximum is 1 character)",
        "other": "is too long (maximum is %{count} characters)"
      },
      "too_short": {
        "one": "is too short (minimum is 1 character)",
        "other": "is too short (minimum is %{count} characters)"
      },
      "wrong_length": {
        "one": "is the wrong length (should be 1 character)",
        "other": "is the wrong length (should be %{count} characters)"
      }
    }
  },
  "esm": "ESM",
  "esm_class_registration": {
    "class_needs_bronze_membership": "This class requires the rider has a bronze membership with Equestrian Canada.  A Temporary Rider Fee will be charged.",
    "class_needs_gold_member_with_equestrian_canada": "This class requires the rider has a gold membership with Equestrian Canada.  A Temporary Rider Fee will be charged.",
    "class_needs_gold_member_with_upgrade_fee": "This class requires the rider has a gold membership with Equestrian Canada.  An upgrade Fee will be charged.",
    "class_needs_sliver_membership_with_equestrian_canada": "This class requires the rider has a silver membership with Equestrian Canada.  A Temporary Rider Fee will be charged.",
    "class_needs_sliver_membership_with_upgrade_fee": "This class requires the rider has a silver membership with Equestrian Canada.  An upgrade Fee will be charged."
  },
  "esm_help_email": "support@showmanagementsystem.com",
  "exhibitor": {
    "activate_your_account": "Click on the link in the email to activate your account.",
    "add_another_mobile_alert": "Add Another Mobile Number to Alert",
    "advisory_message": "ADVISORY: If you change the email on this profile, it will not take effect until it is confirmed.",
    "casl": "CASL",
    "casl_agree": "I give consent under %{casl_link}",
    "casl_continue": "You must give consent under CASL to continue",
    "company_information_label": "Company Information",
    "company_not_person": "Hint: You create a company when a horse is owned by a company and not a person",
    "company_search": "Company Search",
    "company_search_hint": "Hint: Partial names work. Type at least two letters.",
    "create_exhibitor_button": "Create Exhibitor",
    "create_horse_wizard": "Create Horse Wizard",
    "create_new_person_company_button_label": "Create new Person or Company",
    "create_person_button": "Create New Person or Company",
    "create_person_header": "Create Person Wizard",
    "create_person_popup_email": "This email must be unique because it will be the person's user name in ESM. If the person does not have an email enter first name.last name@esm.horse.",
    "create_person_popup_mobile": "If the person does not have a mobile, enter the Trainer's or Parent's mobile.",
    "date_of_birth_pop": "Select the Month and/or Year first, then the Day. \nThis is used to calculate competition eligibility if there are age restrictions.",
    "do_not_create_dupe": "If the person is already in ESM, DO NOT create a duplicate profile; this will cause problems.",
    "ea_not_valid": "%{ea} number is not on the sanctioning body database. Please enter a valid number. \n",
    "ea_try_none": "Error while checking membership numbers. Perhaps you want to check a None option?",
    "edit_exhibitor_header": "Edit Exhibitor",
    "email_confirmed_ago": "email confirmed %{confirmed_at} ago",
    "email_not_confirmed": "email not confirmed",
    "email_pop": "This email will be your user ID for signing in to ESM. It must be verified before the account will be active.",
    "enter": "Enter",
    "enter_valid_number": " number is not on the sanctioning body database. Please enter a valid number. \n",
    "exhibitor_home_title": "Exhibitor Home",
    "exhibitor_word": "Exhibitor",
    "faq_22_body": "You may have a Person account, not an Exhibitor account. Only Exhibitor accounts can submit horse entries and services orders to shows. Person accounts exist in Exhibitor accounts and can only run reports. To easily check if you have an Exhibitor account, sign in to ESM. If the first button on your home screen is Entries/Service Orders, then you have an Exhibitor account. If the first button on your home screen is Reports, then you have a Person account.",
    "faq_22_header": "Why can't I submit show entries using my ESM account?",
    "faq_23_body": "Only Exhibitor accounts can submit horse entries and services orders to shows. Exhibitor accounts contain People profiles (each person in an Exhibitor account has their own ESM Person account that can be used to check show results, schedules, how many, and other things), Horse profiles, and Show Entries. To easily check if you have an Exhibitor account, sign in to ESM. If the first button on your home screen is Entries/Service Orders, then you have an Exhibitor account. If the first button on your home screen is Reports, then you have a Person account.",
    "faq_23_header": "What is the difference between an Exhibitor account and a Person account?",
    "faq_24_body": "Please contact us at help@esm.horse and we will help you.",
    "faq_24_header": "What do I do if I am a person in somebody's exhibitor account, and I want my own exhibitor account so that I can submit show entries?",
    "fill_out_fields": "IMPORTANT! You must fill out the highlighted fields before you press Create. Fill out other fields if you know them. Don’t forget to add any other memberships that they have! Check the dropdown list for supported memberships.",
    "final_create_notice": "When you press the Create Exhibitor button, you will be sent an email to validate your email address. Click on the link in the email to activate your account.",
    "gate_time_reminder": "Minutes before my next estimated in gate time send a text reminder to:",
    "having_trouble": "If you are having trouble using ESM, please contact a show secretary or email",
    "horse_search": "Horse Search",
    "how_do_create_account_header": "How do I create an ESM account?",
    "i_want_to_create_prompt": "I want to create:",
    "incorrect_dob": "You must enter the Date of birth as yyyy-mm-dd.",
    "mobile_confirmed": "Your Mobile Number %{phone_number} is confirmed and ESM can send you messages from show secretaries to this number.",
    "mobile_confirmed_ago": "mobile confirmed %{confirmed_at} ago",
    "mobile_empty": "Your Mobile Number is empty.",
    "mobile_must_verify": "You must verify your mobile number before ESM can send you messages from show secretaries.",
    "mobile_not_confirmed": "mobile is not confirmed",
    "mobile_not_confirmed_with_number": "Your Mobile Number %{phone_number} is not confirmed.",
    "new_exhibtor_company": "New Exhibitor - Company",
    "new_exhibtor_person": "New Exhibitor - Person",
    "parent_guardian_contact": "The Parent/Guardian is the person that shows will attempt to contact if there is an issue regarding this minor.",
    "password_match": "Passwords don't match.",
    "password_pop": "Must be at least 8 characters",
    "people_for_header": "People for %{exhibitor}",
    "people_one_only": "<strong>IMPORTANT:</strong> A person can only have one profile within ESM. Before you try to create a new person in your account, check if they are already in ESM. If they are, and you want them moved to your account, please ask a horse show secretary.",
    "people_remove": "To remove people from your account, please ask a horse show secretary.",
    "people_title": "People Home",
    "person_already_exists": "%{person} is already in ESM in the account of %{exhibitor}. A person or company can only have one profile in ESM. If you would like this person or company moved to your account, please contact any show secretary or help@esm.horse and we will help you.",
    "person_information_label": "Person Information",
    "person_search": "Person Search",
    "person_search_hint": "Hint: Partial names work. Type at least two letters of the first AND last name.",
    "person_search_results": {
      "enter": "Enter",
      "this": "This"
    },
    "phone_pop": "Enter the best telephone number to reach the person.",
    "press_exhibitor_account": "When you press the Create Exhibitor button, you will be sent an email to validate your email address.",
    "rts_message": "This application can only be used for a show that is open for registration and in which you are associated with an entry which has purchased MyESM Real Time Show.",
    "search_before_create": "Before you create a new person or company in your ESM account, make sure that they are not already in the system by typing their name in the box below and pressing Search.",
    "search_important_banner": "<p><b>IMPORTANT If you recognize your information in the chart above, but the email listed is NOT a valid email, contact <a target=\"_blank\" href=\"mailto:help@esm.horse\">help@esm.horse</a> and we will change the email on your account to a valid one.</b></p>",
    "search_not_see": "If you do not recognize your information in the chart above press Create New ESM Account to sign up for a free ESM account.",
    "search_tip_1": "If the person/company is already in ESM, DO NOT create a duplicate profile; this will cause problems.",
    "search_tip_2": "You can still submit show entries using them by selecting Person Not In My Account when creating your entries.",
    "search_tip_3": "If you feel that you want the person/company moved from the current Exhibitor account to your account, please ask the show secretary at any ESM show or contact us at help@esm.horse and we will help you.",
    "search_tip_4": "Otherwise, if the person/company is NOT in ESM, press the button below to create them.",
    "select_their_coach": "If the person is a rider, select their coach. A coach can be anyone in the ESM system. They do not have to be on your People file.",
    "terms_agree": "I agree with the %{terms_link}",
    "terms_continue": "You must agree to the Terms & Conditions to continue",
    "text_me_code": "Text Me the Verification Code",
    "they_have_memberships_prompt": "They have the following Memberships:",
    "this": "This",
    "this_is_a": "This is a",
    "tip_1": "The first thing that you need to decide when you are creating a new ESM account is whether or not you will be submitting show Entries. If yes, you need an Exhibitor account (you must be at least 18 years old to have an Exhibitor account). If no, then you need a Non Exhibitor account.",
    "tip_2": "If you need an Exhibitor account, you must know if you will be submitting Entries as a company or as an individual. Most stables are companies, and like to submit Entries and pay show fees under their corporate name. Remember to fill out all the mandatory fields (they are marked with an asterisk).",
    "tip_3": "If you need a Non Exhibitor account, you must get an someone with an Exhibitor account to create it for you in their account. If you have an Exhibitor account and want to create a Non Exhibitor account press Create a Non Exhibitor account for step by step instructions. *Note: an Exhibitor may use any Non Exhibitor or other Exhibitor in the entire ESM system as part of show Entries. See Creating Show Entries for more details.",
    "tip_4": "Otherwise, if the person/company is NOT in ESM, press the button below to create them.",
    "trained_by_hint": "<i>If the person is a rider, select their coach. A coach can be anyone in the ESM system. They do not have to be on your People file. <strong>IMPORTANT! If the coach is not already on the system, you must create them BEFORE creating this new person.</strong></i>",
    "trained_by_label": "Coached by",
    "trainer_data": "trainer data is valid",
    "type_of_account": "Type of Account",
    "update_exhibitor_button": "Update Exhibitor",
    "warning_create_one_account": "IMPORTANT: Do not create more than one ESM account.  For more info click <a href=\"/user_faq\">HERE</a>",
    "warning_uncheck_this_box": "WARNING! If you uncheck this box you will no longer receive important emails from shows where you are entered!",
    "you_must_be_18": "You MUST be over 18 to create an account"
  },
  "fees": {
    "all_riders": "All Riders",
    "class_fees": "Class Fees",
    "dressage_fee": "Dressage Fee",
    "drug": "Drug",
    "horse_fees": "Horse Fees: %{amount}",
    "horse_fees_split": "* HORSE FEES and SERVICES FEES are split equally between riders.",
    "how_to_pay": "I intend to pay for this entry by:",
    "late_fee": "Late Entry Fee",
    "medic": "Medic",
    "no_pay": "No money is owed at this time.",
    "non_taxable": "Non Taxable Fees",
    "non_taxable_subtotal": "Non Taxable Subtotal",
    "order_summary": "Order Summary",
    "owing": "Owing: %{amount}",
    "pay_online": "Or you can pay online now",
    "payments": {
      "cash": "Cash",
      "cheque": "Cheque payable to ",
      "debit": "Debit/Credit by calling ",
      "etransfer": "E-transfer to ",
      "online": "Pay online with Debit/Credit"
    },
    "prize_money": "Prize Money",
    "prize_money_less": "Less Prize Money:",
    "return_show": "Return to Show",
    "rider_fees": "Rider Fees: %{amount}",
    "rider_share_net": "Rider Share of Net",
    "scratch_fee": "Scratch Fee",
    "services_fees": "Services Fees: %{amount}",
    "ship_fees": "Ship In Fee",
    "subtotal": "Subtotal: ",
    "subtotal_after_tax": "Subtotal After Tax",
    "subtotal_services": "Subtotal Services:",
    "summary": "Summary",
    "tax_number": "%{name} Number: %{number}",
    "taxable": "Taxable Fees",
    "taxable_subtotal": "Taxable Subtotal",
    "total": "Total %{item}",
    "total_fees": "Total Fees: %{fees}",
    "total_owing": "Total Owing:",
    "total_with_tax": "Total with Tax",
    "you_may_pay": "You may pay all or a portion of this entry with any of the following methods. For all methods, please indicate the show and horse you are paying for."
  },
  "first_name": "First Name",
  "flash": {
    "actions": {
      "create": {
        "notice": "%{resource_name} was successfully created."
      },
      "destroy": {
        "alert": "%{resource_name} could not be destroyed.",
        "notice": "%{resource_name} was successfully destroyed."
      },
      "update": {
        "notice": "%{resource_name} was successfully updated."
      }
    }
  },
  "generated_at": "Generated at: ",
  "go": "Go",
  "help_link": "Help",
  "helpers": {
    "select": {
      "prompt": "Please select"
    },
    "submit": {
      "create": "Create %{model}",
      "submit": "Save %{model}",
      "update": "Update %{model}"
    }
  },
  "here": "HERE",
  "home": {
    "esm": "Equestrian Show Manager",
    "esm_welcome1": "Welcome to Equestrian Show Manager",
    "esm_welcome2": "From here you can enter shows and check your results.",
    "french_banner": "Nous avons de bonnes nouvelles! CEG (ESM en français)  est maintenant disponible en français! Pour utiliser le français, sélectionnez FR dans la liste déroulante dans le coin supérieur droit de l’écran. Veuillez nous excuser si vous rencontrez un peu d’anglais à l’occasion. Nous sommes encore en train de terminer les dernières parties, mais nous voulions vous remettre notre version française le plus tôt possible.",
    "learn_account_company": "Learn how to create a new exhibitor account as a company %{link}",
    "learn_account_person": "Learn how to create a new exhibitor account as a person %{link}",
    "not_sure_search": "Not sure if you already have an ESM account?",
    "sign_in": "If you have a account, sign in now.",
    "sign_up": "Otherwise you can sign up for a free account.",
    "trouble_contact": "If you are having trouble using ESM, please contact a show secretary or email %{email}",
    "warning_more_accounts": "IMPORTANT: Do not create more than one ESM account.  For more info click %{link}"
  },
  "home_link": "Home",
  "horse": {
    "add_owner": "Add Owner",
    "add_recording": "Add Recording #",
    "add_the_horse_owners": "Add the horse owners",
    "age_years": "Age (years)",
    "click_button_to_create_horse": "Otherwise, if your horse is NOT in ESM, press the button below to create it",
    "create_horse": "Create Horse",
    "create_new_horse": "Create New Horse",
    "date_of_birth_popup": "Select the Month and/or Year first, then the Day.",
    "delete_vax": "Delete Vax Cert",
    "do_not_create_duplicate_profile": "If your horse is already in ESM, DO NOT create a duplicate profile; this will cause problems.",
    "ec": "EC",
    "edit_horse": "Edit Horse",
    "enter_valid_number": " number is not on the sanctioning body database. Please enter a valid number. \n",
    "error_label": "error",
    "fei": "FEI",
    "horse_already_exists": "%{horse_name} is already in ESM in the account of %{exhibitor_name}. A horse can only have one profile in ESM. If you would like this horse moved to your account, please contact any show secretary or help@esm.horse and we will help you.",
    "horse_already_in_system": "Before you create a new horse in ESM, make sure that your horse is not already in the system by typing your horse’s name in the box below and pressing Search.",
    "horse_information": "Horse Information:",
    "horse_moved_to_current_exhibitor": "If you feel that you want your horse moved from the current Exhibitor account to your account, please ask the show secretary at any ESM show or contact us at help@esm.horse and we will help you",
    "horse_one_only": "<strong>IMPORTANT:</strong> A horse can only have one profile within ESM. Before you try to create a new horse in your account, check if it is already in ESM. If if is, and you want it moved to your account, please send an email to help@esm.horse.",
    "horse_recording": "Horse Recording #",
    "horse_recording_numbers": "Horse Recording Numbers",
    "horse_remove": "To remove horses from your account please send an email to help@esm.horse.",
    "horses_for": "Horses for %{name}",
    "issuing_body": "Issuing Body",
    "manage_horses": "Manage Horses",
    "new_horse": "New Horse",
    "no_dob": "No date of birth",
    "notes_about_horse": "Use this field for any notes you want to keep about the horse. They will not be transferred to any entries.",
    "number": "Horse #",
    "owner": "Owner",
    "person_search_result": "Person Search Results",
    "please_select": "Please select",
    "please_select_a_trainer": "please, select a trainer",
    "recording_numbers_for_this_horse": "Add all the Horse Recording Numbers for this horse. These will be automatically transferred to your entries.",
    "remove_owner": "Remove Owner",
    "remove_recording": "Remove Recording #",
    "search_results": "Search Results",
    "sex": {
      "g": "G",
      "m": "M",
      "s": "S"
    },
    "size": {
      "l": "L",
      "m": "M",
      "s": "S"
    },
    "submit_show_entries": "If your horse is already in ESM, DO NOT create a duplicate profile; this will cause problems. You can still submit show entries for your horse by selecting Horse Not In My Account when creating your entries.",
    "this_is_the_show_name_of_the_horse": "This is the Show Name of the horse",
    "this_is_used_to_determine_eligibility_for_comp": "This is used to determine eligibility for competitions",
    "type": "Type",
    "update_horse": "Update Horse",
    "upload_new_vax_cert": "Upload New Vax Cert",
    "usef": "USEF",
    "vaccination_certificate": "Vaccination Certificate",
    "vax_expiry": "Vaccination Expiry Date",
    "verified_by": "Verified by %{person} on %{date}",
    "view_vax_cert": "View Vax Cert"
  },
  "important_all_caps": "IMPORTANT",
  "invalid_date": "Invalid date (format: yyyy-mm-dd)",
  "large": "Large",
  "last_name": "Last Name",
  "loading": "Loading...",
  "logged_in_link": "Logged in: %{user}",
  "make_payment_label": "Make a Payment",
  "mandatory_field": "* Indicates a mandatory field",
  "medium": "Medium",
  "mobile_number_prompt": "Mobile Number",
  "my_account_link": "My Account",
  "name": "Name",
  "next_button_label": "Next",
  "next_year": "Next Year",
  "none": "None",
  "not_logged_in": "Not logged in",
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "negative_format": "-%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "round_mode": "default",
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "Billion",
          "million": "Million",
          "quadrillion": "Quadrillion",
          "thousand": "Thousand",
          "trillion": "Trillion",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB",
          "zb": "ZB"
        }
      }
    },
    "nth": {},
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "or": "or",
  "pay": "Pay $%{amount}",
  "per": "per",
  "person_label": "Person",
  "please_wait": "please wait...",
  "prev_year": "Prev Year",
  "print": "Print",
  "reports": {
    "all_classes": "All Classes",
    "all_divisions": "All Divisions",
    "all_rings": "All Rings",
    "all_trainers": "All Trainers",
    "as_of_messge": "* indicates a rider who was under 18 years of age as of January 01.",
    "bracket_number": "The number in brackets after the class name is the number registered in the class. The second number is the estimated number of minutes that the class will take to run.",
    "circuit_points_as_of": "Circuit Points as of %{date}",
    "circuit_results_to_date": "Circuit Results to Date",
    "circuit_results_to_date_csv": "Circuit Results to Date (CSV)",
    "circuit_secretary_reports": "Circuit Secretary Reports",
    "circuit_standings_as_of": "Trainer Circuit Standings as of %{date}",
    "class_name": "Class Name",
    "class_number": "Class Number",
    "division_class": "Division/Class Schedule",
    "divisions": "%{division} Divisions",
    "end": "End",
    "entries": "Entries",
    "entries_class": "Entries by Class",
    "event_name": "Event Name",
    "facility": "Facility: %{facility}",
    "fee_summary": "Fee Summary",
    "fee_summary_csv": "Fee Summary (CSV)",
    "fees_collected": "Fees Collected",
    "fees_collected_csv": "Fees Collected (CSV)",
    "financial_reports": "Financial Reports",
    "full_show_results": "Full Show Results",
    "generate_pdf": "Generate PDF Report",
    "get_results": "Get Results",
    "high_points_rider_as_of": "High Points Rider for Circuit as of %{date}",
    "high_points_rider_circuit": "High Points Rider for Circuit",
    "how_many_class": "How Many by Class",
    "how_many_division_class": "How Many (by Division/Class)",
    "no_results": "No Results",
    "number_entries": "# of Entries",
    "number_shows": "# of Shows Entered",
    "numbers_completed": "Numbers Completed: ",
    "open_csv": "Open CSV Saved %{time} Ago",
    "open_report": "Open Report Saved %{time} Ago",
    "outstanding_fees_owning_by_horse": "Outstanding Fees Owning by Horse",
    "outstanding_fees_owning_by_rider": "Outstanding Fees Owning by Rider",
    "report_csv_not_generated": "CSV for this Show has not been Generated Yet",
    "report_not_generated": "Report has not been Generated Yet",
    "report_show_not_generated": "Report for this Show has not been Generated Yet",
    "reports": "Reports",
    "reserve_champion": "Reserve Champion",
    "rider": "Rider",
    "ring": "Ring",
    "rts_message": "*NOTE: THIS IS NOT INFORMATION FROM THE ESM REALTIME™ SCHEDULE. IF ESM REALTIME SCHEDULE IS AVAILABLE FOR THIS SHOW, YOU CAN ACCESS IT BY PURCHASING THE MYESM REALTIME SHOW APP FOR THIS SHOW.",
    "schedule_estimated": "Schedule - Estimated*",
    "scoreboard_csv": "Scoreboard (CSV)",
    "second_reserve_champion": "2nd Reserve Champion",
    "select_circuit": "Select Circuit",
    "select_division": "Select a Division",
    "select_ring": "Select Ring",
    "select_trainer": "Select a Trainer",
    "select_year": "Select Year",
    "show_and_circuit_results": "Show & Circuit Results",
    "show_dates": "Show Dates: %{start} - %{end}",
    "show_entries": "Show Entries",
    "show_results": "Show Results",
    "show_schedule": "Show Schedule",
    "show_schedules": "Show Schedules",
    "show_secretary_reports": "Show Secretary Reports",
    "sponsored": "Sponsored By: ",
    "start": "Start",
    "start_time": "Scheduled Start Time",
    "thoroughbred_points": "Thoroughbred High Points",
    "trainer": "Trainer",
    "trainer_circuit_standings": "Trainer Circuit Standings",
    "trainer_placings": "Trainer Placings",
    "trainer_report": "Trainer Report",
    "trainer_reports": "Trainer Reports"
  },
  "rts": {
    "active_show": "Active Purchased Shows",
    "course_layout": {
      "course_layout": "Course Layouts",
      "layout_available": "This layout will be available at %{time}",
      "no_layout": "Show management has not made this layout available yet."
    },
    "facility_map": "Facility Map",
    "ingate": "In Gate",
    "myesm_home": "MyESM Home",
    "placings": {
      "placings": "My Placings"
    },
    "prizes": {
      "prizes": "My Prizes"
    },
    "ring_schedule": {
      "ring_schedule": "Ring Schedule",
      "ring_schedule_rt": "Real Time Ring Schedule",
      "select_ring": "Select Ring:"
    },
    "rts_home": "RTS Home",
    "schedule": "Ring Schedule",
    "services": {
      "assignments": "Assignments",
      "bedding": "Bedding",
      "campsites": "Campsites",
      "check": "Horse Check",
      "daily": "Daily",
      "daily_campsites": "Daily Campsites",
      "daily_stalls": "Daily Stalls",
      "delivered": "Delivered",
      "delivery_date": "Delivery Date",
      "hay": "Hay",
      "new_services_entry": "New services entry for %{name}",
      "paddocks": "Paddocks",
      "qty": "Qty",
      "rate": "Rate",
      "resources": {
        "bags": "bags",
        "bales": "bales",
        "horse": "horse/nights",
        "paddock": "paddock/"
      },
      "services": "My Services",
      "show_campsites": "Show Campsites",
      "show_duration": "Show Duration",
      "show_stalls": "Show Stalls",
      "sold_out": "Sold Out",
      "stalls": "Stalls",
      "stalls_daily": "Stalls (Daily)",
      "stalls_show": "Stalls (Show)",
      "starting_from": " day(s) starting from "
    },
    "text_alerts": {
      "alerts": "Text Alerts",
      "current_reminder_esm": "Current Reminders to ESM users",
      "current_reminder_others": "Current Reminders to others",
      "minutes_before": "Minutes Before%{colon} ",
      "mobile": "Mobile Number",
      "recipient": "Recipient"
    },
    "when_do_i_go": {
      "choose_class": "Choose a Class:",
      "class_not_scheduled": "Class not scheduled",
      "class_start": "Class Start",
      "classes": "Classes:",
      "clear_round": "Clear Round",
      "completed_type": "Completed %{type}",
      "entry": "Entry #",
      "flights": "Flights",
      "jump_off": "Jump Off",
      "more_info": "Tap any class name to see more info. Only entries with RTS purchased are shown here.",
      "qualified_for": "Qualified for %{item}, (%{time})*",
      "ring_label": "Ring",
      "rounds": "Rounds",
      "rt_in_gate": "Real Time In Gate",
      "speed": "Speed",
      "trainer_rider": "Trainer / Owner / Rider / Horse",
      "type_completed": "%{type} Completed (%{time})**",
      "when_go": "When Do I Go?"
    }
  },
  "rts_full": "MyESM Real Time Show",
  "save_continue": "Save & Continue",
  "search": "Search",
  "season_stalls": {
    "amount": "Amount",
    "assignments": "%{type} Assignments",
    "camping_notes": "Camping Notes",
    "camping_notes_colon": "Camping Notes: %{note}",
    "campsite": "Campsite",
    "campsite_assignments": "Campsite Assignments",
    "campsite_notes": "Campsite Notes",
    "campsites": "Campsites",
    "campsites_daily": "Campsites (Daily)",
    "campsites_show": "Campsites (Show)",
    "correct_order": "Are you sure your order is correct? You can change this order up to the time where you have been assigned specific %{type}s. After that, you must call at to make any changes.",
    "day": "Day",
    "delete_confirm": "Delete Season %{type} Order for Circuit %{circuit}?",
    "edit_order": "Orders cannot be edited once %{type} have been assigned. For assistance contact",
    "email_order": "Email for Season %{type} Orders",
    "fee_adjustments": "Fee Adjustments",
    "name": "Name: %{name}",
    "payments": "Payments",
    "phone": "Phone: %{phone}",
    "receipt": "Receipt",
    "save": "Save Changes",
    "season_order": "Season %{type} Rental Order",
    "seasonal_order": "Seasonal %{type} Rental Order",
    "show_functions": "Show Secretary Functions",
    "stabling": "Stabling",
    "stabling_notes": "Stabling Notes",
    "stabling_notes_colon": "Stabling Notes: %{note}",
    "stall": "Stall",
    "stalls": "Stalls",
    "submit_order": "Submit Order",
    "telephone_order": "Telephone for Season %{type} Orders",
    "type": "%{type} Type",
    "unassigned": "Unassigned"
  },
  "select_date": "Select Date",
  "service_entry": {
    "no_services_available": "There are no services availalbe for this show"
  },
  "show": {
    "create_new_show_page_header": "Create New Show (Step 1)",
    "create_new_show_title": "Create New Show",
    "create_show_button_label": "Create Show",
    "select_facility_label": "Select Facility",
    "select_facility_prompt": "Choose a Facility Profile",
    "select_show_label": "Select a Show",
    "select_show_template_label": "Select Show Template",
    "select_show_template_prompt": "Choose a Show Template",
    "start_date_hint": "Select the Month and/or Year first, \nthen the Day."
  },
  "sign_in": "Sign in",
  "sign_in_page": {
    "email": "Email",
    "forgot_password": "Forgot your password?",
    "no_confirmation": "Didn't receive confirmation instructions?",
    "password": "Password",
    "remember_me": "Remember me",
    "resend_instructions": "Resend Confirmation Instructions",
    "reset_pass_instructions": "Send me Reset Password Instructions"
  },
  "sign_out": "Sign out",
  "sign_up": "Sign up",
  "simple_form": {
    "error_notification": {
      "default_message": "Please review the problems below:"
    },
    "hints": {
      "registrant": {
        "allow_emailing": "WARNING! If you uncheck this box you will no longer receive important emails from shows where you are entered!",
        "allow_texting": "WARNING! If you uncheck this box you will no longer receive important text messages from shows where you are entered!"
      },
      "user": {
        "allow_emailing": "WARNING! If you uncheck this box you will no longer receive important emails from shows where you are entered!",
        "allow_texting": "WARNING! If you uncheck this box you will no longer receive important text messages from shows where you are entered!"
      }
    },
    "labels": {
      "esm_class": {
        "estimated_changeover_time": "Estimated changeover time in minutes before the class can be started",
        "estimated_time_for_class": "Estimated time for class (minutes)",
        "estimated_time_per_rider": "Estimated time per rider (minutes)",
        "estimated_time_per_rider_for_jump_off": "Estimated time per rider for jump off (minutes)",
        "estimated_time_per_rider_for_power": "Estimated time per rider for Power (minutes)",
        "estimated_time_per_rider_for_qualification": "Estimated time per rider for jump off qualification (minutes)",
        "estimated_time_per_rider_for_speed": "Estimated time per rider for Speed (minutes)",
        "ribbon_award_time": "Ribbon Award Time"
      },
      "individual_show": {
        "default_ribbon_award_time": "Default Ribbon Award Time"
      },
      "registrant": {
        "company_name": "Company Name",
        "contact_name": "Contact Name",
        "tax_number": "Tax ID"
      },
      "user": {
        "company_name": "Company Name",
        "contact_name": "Contact Name",
        "tax_number": "Tax ID"
      }
    },
    "no": "No",
    "required": {
      "mark": "*",
      "text": "required"
    },
    "yes": "Yes"
  },
  "small": "Small",
  "support": {
    "array": {
      "last_word_connector": ", and ",
      "two_words_connector": " and ",
      "words_connector": ", "
    }
  },
  "terms_link": "Terms and Conditions",
  "time": {
    "am": "am",
    "formats": {
      "default": "%a, %d %b %Y %H:%M:%S %z",
      "long": "%B %d, %Y %H:%M",
      "short": "%d %b %H:%M"
    },
    "pm": "pm"
  },
  "time_not_set": "time not set",
  "user": {
    "account_search": "Account Search",
    "add_another_guardian": "Add another Parent/Guardian contact",
    "company_name_account": "Company Name on Account",
    "create_label": "Create",
    "create_person_label": "Create Person",
    "duplicate": "If you already have an ESM account, DO NOT create a duplicate; this will cause problems.",
    "edit_person_and_company": "Edit Person / Company",
    "edit_profile": "Edit Profile",
    "email_hidden": "Zip / Postal / Email are partially masked to protect privacy",
    "faq": {
      "account_merged_moved_body": "Each person is only allowed one ESM account. That way ESM can let you see all of your show activities in one place. If ESM discovers that you have more than one account, we help you by merging the information in all your accounts into a single account. Any time this happens, you are sent an email advising you of what to do if you think that there has been a mistake.",
      "account_merged_moved_header": "I received an email saying that my account has been merged or moved. Why did this happen?",
      "change_account_to_submit_body": "You must be 18 years or older to have an ESM Exhibitor account that will let you submit show Entries and Service Orders. If you feel that you want to change your Non Exhibitor account to an Exhibitor account that will allow you to submit show entries, a show secretary can assist you.",
      "change_account_to_submit_header": "I want to change my ESM account so that I can submit show entries. How do I do it?",
      "change_barn_trainer_body": "Any show secretary can move your ESM account. Talk to them at the show office.",
      "change_barn_trainer_header": "I have changed my barn or trainer. How do I move my ESM account?",
      "confused_body": "You can ask any ESM show secretary for help with any account problem. If they can’t help you, they will get in touch with ESM, and together we will resolve your problem.",
      "confused_header": "I am really confused. How can I get help with my ESM account?",
      "cost_new_account_body": "Exhibitor and Non Exhibitor ESM accounts are free. You can use them to check show/circuit results and manage your Entries. Once you have created your account, you have the option of purchasing premium show services such as smartphone access to ESM Real Time Schedule, course layouts and service deliveries.",
      "cost_new_account_header": "How much does it cost to create an ESM account?",
      "create_new_account_body": "The first thing that you need to decide when you are creating a new ESM account is whether or not you will be submitting show Entries. If yes, you need an Exhibitor account (you must be at least 18 years old to have an Exhibitor account). If no, then you need a Non Exhibitor account. If you need an Exhibitor account, you must know if you will be submitting Entries as a company or as an individual. Most stables are companies, and like to submit Entries and pay show fees under their corporate name. Press Create an Exhibitor Account for a Company or Create an Exhibitor Account for a Person for step by step instructions. Remember to fill out all the mandatory fields (they are marked with an asterisk). If you need a Non Exhibitor account, you must get an someone with an Exhibitor account to create it for you in their account. If you have an Exhibitor account and want to create a Non Exhibitor account press Create a Non Exhibitor account for step by step instructions. *Note: an Exhibitor may use any Non Exhibitor or other Exhibitor in the entire ESM system as part of show Entries. See Creating Show Entries for more details.",
      "create_new_account_header": "How do I create a new ESM account?",
      "exhibitor_no_phone_body": "If you are creating a Non Exhibitor account for someone who does not have a mobile phone, you can use your own mobile number or the number of one of their parents. Unlike email addresses, you can use the same mobile number for multiple ESM accounts. Remember that a mobile number must be validated separately for each account in which it is used.",
      "exhibitor_no_phone_header": "One of the people in my Exhibitor account doesn’t have a mobile phone. What do I do?",
      "exhibitor_person_difference_body": "Only Exhibitor accounts can submit horse entries and services orders to shows. Exhibitor accounts contain People profiles (each person in an Exhibitor account has their own ESM Person account that can be used to check show results, schedules, how many, and other things), Horse profiles, and Show Entries. To easily check if you have an Exhibitor account, sign in to ESM. If the first button on your home screen is Entries/Service Orders, then you have an Exhibitor account. If the first button on your home screen is Reports, then you have a Person account.",
      "exhibitor_person_difference_header": "What is the difference between an Exhibitor account and a Person account?",
      "have_esm_account_body": "If you don’t know if you already have an ESM account, press the Find My Account button, fill out the search form, and ESM will search for your account.",
      "have_esm_account_header": "Do I have an ESM Account?",
      "horse_moved_merged_body": "Each horse can have only one profile in ESM. That way ESM can keep track of every show in which a horse is entered and make sure that there are no errors in their show/circuit points, even if a horse changes stables or owners. If ESM discovers that a horse has more than one profile, we help you by merging the information in all the horse’s profiles into a single profile. Any time this happens, ESM sends an email advising you of what to do if you think there has been a mistake.",
      "horse_moved_merged_header": "I received an email saying that a horse in my account has been moved or merged to another ESM account. Why did this happen?",
      "how_submit_entry_exhibitor_body": "An Exhibitor can submit a show Entry for any person or horse in the ESM system. To see how to do this, press the button Submit an Entry for a Person and Horse not in my account.",
      "how_submit_entry_exhibitor_header": "I have an ESM Exhibitor account. How can I submit show Entries for a rider or a horse who is not in my account?",
      "label": "User Account FAQ",
      "mobile_mandatory_body": "A valid mobile phone number is mandatory on all ESM accounts so that you can receive important text communications from shows. The same mobile phone number can be used on multiple ESM accounts. So for example, if you are a coach taking several young riders to shows, and you want to receive all texts concerning their show entries, you can put your mobile number on each of their accounts. If you do this, you will have to validate your mobile number on each of their accounts separately.",
      "mobile_mandatory_header": "Why is the mobile phone number field mandatory?",
      "multiple_accounts_one_number_body": "Yes! The same mobile number can be used on multiple ESM accounts. This situation often occurs when a coach is responsible for multiple young riders and does not want them to receive texts directly from shows. **Important** If you use the same mobile number on multiple ESM accounts, you must validate the number separately for each account on which you use it. To see how to validate a mobile phone number, press the button How to Validate a Mobile Number.",
      "multiple_accounts_one_number_header": "Can more than one ESM account use the same mobile phone number?",
      "multiple_people_one_email_body": "No. Each ESM account must have a unique and valid email address. The email address in an account is how ESM identifies individual people.",
      "multiple_people_one_email_header": "Can more than one person use the same email for their account?",
      "new_person_no_email_body": "You can get a free Gmail account from Google <a href='https://accounts.google.com/signup/v2/webcreateaccount?flowName=GlifWebSignIn&flowEntry=SignUp'>HERE</a>. You can then validate and use this account. If you are using the account for a Non Exhibitor account, you can validate the email on their behalf. ***Important*** If you are an Exhibitor who is creating a Non Exhibitor account for someone, don’t forget to tell them their ESM Email and Password so that they can log in to ESM and use their account.",
      "new_person_no_email_header": "I want to create a new person in my account. They are young and don’t have their own email. What do I do?",
      "not_able_to_submit_entries_body": "You may have a Person account, not an Exhibitor account. Only Exhibitor accounts can submit horse entries and services orders to shows. Person accounts exist in Exhibitor accounts and can only run reports. To easily check if you have an Exhibitor account, sign in to ESM. If the first button on your home screen is Entries/Service Orders, then you have an Exhibitor account. If the first button on your home screen is Reports, then you have a Person account.",
      "not_able_to_submit_entries_header": "Why can’t I submit show Entries with my ESM account?",
      "one_account_body": "One of the powerful things about ESM is that it can let you keep track of all of your horse show activity in one place. But ESM can only do this for you if you have one, and only one account. ESM views each account as a different person, so if you create more than one account, you may, for instance, not get credit for all of the points you win in different shows. ESM has some safeguards to prevent you from accidentally creating more than one account, but ultimately, this is your responsibility. If you have created more than one ESM account, any show secretary can help you to fix this. Just go into the show office and ask.",
      "one_account_header": "Why can I only have one ESM account?",
      "person_want_exhibitor_body": "Please contact us at help@esm.horse and we will help you.",
      "person_want_exhibitor_header": "What do I do if I am a person in somebody's exhibitor account, and I want my own exhibitor account so that I can submit show entries?",
      "submit_entry_exhibitor_body": "No. Anyone with an ESM Exhibitor account can enter you in a show, even if you are not in their account.",
      "submit_entry_exhibitor_header": "Can only one Exhibitor submit show entries for me as a rider?",
      "two_types_body": "There are two types of ESM account: Non Exhibitor and Exhibitor. If you have a Non Exhibitor account, you can appear on show entries as a Rider, Owner or Trainer, check show/circuit results, and access ESM Real Time features on your smartphone. An Exhibitor account gives you all the features of a Non Exhibitor account, but in addition, an Exhibitor account lets you: 1. Submit Horse Entries and Services Orders for shows, 2. Create Non Exhibitor accounts, and 3. Create Horse profiles to use in show Entries. You must be at least 18 years old to have an Exhibitor account because a Horse Entry or Services Order is a legal contract with a show.",
      "two_types_header": "What are the two types of ESM account?",
      "valid_email_body": "ESM uses your email for two things: to provide a unique identifier for your account, and to allow us and show managers to communicate with you. All ESM accounts, Non Exhibitor and Exhibitor must have valid emails. You will be asked to validate your email before you can use your ESM account. If you are and Exhibitor creating a Non Exhibitor account for someone without an email (e.g. a young child), you can get a free Gmail account from Google <a href='https://accounts.google.com/signup/v2/webcreateaccount?flowName=GlifWebSignIn&flowEntry=SignUp'>HERE</a>. You can then validate and use this account on their behalf. If you don’t have a valid email account, ESM and shows can’t reach you with important information.",
      "valid_email_header": "Why do I have to have a valid email to create an ESM account?",
      "validate_email_body": "Each ESM Exhibitor and Non Exhibitor ESM account must have a validated email in order to use it. When an account is created, ESM will send you an email containing a validation link. To see how this works, press the button How to Validate an ESM Email.",
      "validate_email_header": "How do I validate an email?",
      "validate_phone_body": "Each ESM Exhibitor and Non Exhibitor account must have a mobile phone number. After an account has been created, ESM will give you an opportunity to validate the mobile phone number in the account. ESM needs a separate mobile phone number validation for each account, even if the mobile number has been used for other accounts. ESM will not send text messages to an account until the mobile phone number has been validated. To see how to validate a mobile phone number, press the button How to Validate a Mobile Number.",
      "validate_phone_header": "How do I validate a mobile phone number?"
    },
    "first_name_account": "First Name on Account",
    "last_name_account": "Last Name on Account",
    "parent_guardian": "Parent/Guardian #%{number}",
    "person_not_my_account": "person not in my account...",
    "search_esm_account": "Search For My ESM Account",
    "send_login_info": "Send Login Info",
    "send_login_info_warning": "If you recognize your information in the chart below press “Send Login Info” and check your email for instructions on how to loging to your ESM account.",
    "update_label": "Update",
    "update_person_label": "Update Person",
    "user_search_hint": "Hint: Partial names work. Type at least two letters of the first AND last name.",
    "valid_cell_number": "You MUST enter a valid cell phone number, but it does not have to be unique to this ESM account. Also, this number must be verified. Shows will use this number to text important information about the show entries for this person.",
    "valid_email_address": "This MUST be a valid email address, and it MUST be unique to this person because it will be their user id for logging in to ESM. Also, it must be verified before they can use their account. If they do not have an email account, you can obtain a free one at https://www.google.com/gmail/about/ Shows will use this email to send important information about show entries for this person.",
    "warning_check_for_esm_account": "Before you create a new ESM account, please search ESM to make sure you are not already in the system by typing your name in the box(es) below and pressing Search.",
    "warning_enter_two_letters": "You must enter at least two letters in the First Name AND Last Name fields or at least two letters in the CompanytName field.",
    "will_not_receive_email_warning": "WARNING! If you uncheck this box you will no longer receive important emails from shows where you are entered!",
    "will_not_recieve_messages_warning": "WARNING! If you uncheck this box you will no longer receive important text messages from shows where you are entered!"
  },
  "using_ESM": {
    "create_entry_in_account": "How to create an entry for a horse and rider in your ESM account",
    "create_entry_not_in_account": "How to create an entry for a horse and rider NOT in your ESM account",
    "create_horse_profile": "How to create a new horse profile",
    "create_person": "How to create a new person",
    "create_person_no_email": "How to create a new person who has no email or cell phone",
    "create_service": "How to create a services order",
    "horses": "Horses",
    "how_to_use": "How to Use Your ESM Account",
    "intro": "Introduction to ESM",
    "overview": "An overview of ESM",
    "people": "People",
    "read_first": "READ THIS FIRST",
    "split_service": "How to split a services order"
  },
  "view_button_label": "View",
  "view_pay_button_label": "View/Pay",
  "warning": "Warning: ",
  "will_paginate": {
    "container_aria_label": "Pagination",
    "next_aria_label": "Next page",
    "next_label": "Next &#8594;",
    "page_aria_label": "Page %{page}",
    "page_entries_info": {
      "multi_page": "Displaying %{model} %{from} - %{to} of %{count} in total",
      "multi_page_html": "Displaying %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> of <b>%{count}</b> in total",
      "single_page": {
        "one": "Displaying 1 %{model}",
        "other": "Displaying all %{count} %{model}",
        "zero": "No %{model} found"
      },
      "single_page_html": {
        "one": "Displaying <b>1</b> %{model}",
        "other": "Displaying <b>all&nbsp;%{count}</b> %{model}",
        "zero": "No %{model} found"
      }
    },
    "page_gap": "&hellip;",
    "previous_aria_label": "Previous page",
    "previous_label": "&#8592; Previous"
  },
  "wizard": {
    "action": "Action",
    "add_new_person": "Add New Person",
    "add_to_entry": "Add to Entry >",
    "address_with_colon": "Address:",
    "agree_to_conditions": "I have read the above conditions of this entry and hereby agree to all of the terms.",
    "agree_with_signature": "Please type your First and Last Name",
    "agreement": "I hereby certify that every horse, rider and/or driver is eligible as entered and agree for myself and my representatives to be bound by the Constitution and rules of Equestrian Canada at this competition. It is hereby recognized that all equestrian sports involve inherent risk and that no helmet or protective equipment can protect against all foreseeable injury. I hereby accept this risk and hold harmless EC, the competition, their officials, organizers, agents, employees and their representatives. The person responsible (PR) agrees to the release of any information on the entry form to EC.",
    "all_classes_will_be_deleted": "Are you sure? All classes entered will be deleted.",
    "all_data_will_be_deleted": "All data for this entry will be deleted. Are you sure?",
    "back_button": "< Back",
    "cancel": "Cancel",
    "change_your_search": "If you don’t see the horse you want, change your search.",
    "class_label": "Class",
    "close": "close",
    "coach": "Coach: ",
    "confirm_the_signature": "I understand that by typing my name in the input above constitutes a legal and binding signature in the same way as signing in ink with my own hand.",
    "confrim_to_agreement": "By submitting this registration I confirm that I am over the age of eighteen. I also agree to be bound by the terms and conditions of the show. I also agree to the following Waiver:",
    "contact_for_entry_help": "Contact for entry help: ",
    "create_horse_in_account": "If you are sure the search is right and the horse is not here, create it in your account",
    "create_person_in_account": "If you are sure the search is right and the person is not here, create them in your account.",
    "data_deleted": "All data for this rider will be deleted. Are you sure?",
    "date_of_birth": "Date of Birth:",
    "detail_label": "Details",
    "division_label": "Division",
    "dont_see_person_change_your_search": "If you don’t see the person you want, change your search. ",
    "ec_name": "EC Name:",
    "ec_person_responsible": "EC Person Responsible",
    "ec_verified": "EC Verified:",
    "edit_horse": "Edit Horse if Needed",
    "edit_owner": "Edit Owner",
    "edit_rider": "Edit Rider",
    "email_with_colon": "Email: ",
    "enter_this_horse": "Enter this horse",
    "entry_for": "Entry for %{registrant_name} in %{individual_show}",
    "entry_show": "Entry for %{show}",
    "entry_submitted": "Your entry has been submitted",
    "exbitator_warrant": "In the event that the EC Person Responsible listed on this entry is not the Exhibitor submitting this entry, the Exhibitor warrants that they have the authority to bind the listed EC Person Responsible.",
    "exhibitor_account": "Exhibitor account",
    "exhibitor_label": "Exhibitor",
    "exhibitor_name": "Exhibitor: %{name}",
    "fee_label": "Fee",
    "fees_label": "Fees",
    "fei_name": "FEI Name:",
    "fei_verified": "FEI Verified:",
    "finish_and_start_new_entry": "Finish and Start New Entry",
    "finish_button": "Finish",
    "gather_info_for_possible_tracing": "We are required to gather information for possible contact tracing. Please list below the name, email and telephone number of all people that will be accompanying you to the show who are associated with this entry (other than riders on this entry).",
    "general_show_information": "General show information for: %{name}",
    "horse": "Horse",
    "horse_colon": "Horse: %{horse}",
    "horse_name": "Horse name",
    "horse_not_in_esm": "Select a horse not in my ESM account",
    "horses_meet_requirements": "I hereby certify that every horse listed on this entry form has met the requirements of Article A519, Vaccinations. See Rules of Equestrian Canada, Section A, General Regulations, Article A519, Vaccinations.",
    "how_will_pay": "Please indicate how you intend to pay for this entry",
    "in_the_event": "In the event that any rider on this entry participates in an Equestrian Canada sanctioned competition where protective headgear is required for juniors, he/she will wear properly fitted and fastened approved headgear at all times when riding or driving at the event location. It is understood that juniors not meeting this requirement will not be allowed to compete at these competitions.",
    "late_entry_date": "Late entry date: ",
    "late_entry_fee": "Late entry fee: ",
    "late_fee_warning": "The Late Fee Date for this show has passed. Entries cannot be changed by Exhibitors after the Late Fee Date. You can add classes right at the in gate. For assistance on adding classes or any other changes, please contact the show at %{email}.",
    "lookout_for_next_show": "This show does not have MyESM enabled.  Look out for it on the next show!",
    "mobile_hashtag": "Mobile #",
    "mobile_with_colon": "Mobile:",
    "name_label_colon": "Name:",
    "new_entry_registration_name": "New Entry for %{name}",
    "new_entry_registration_wizard": "New Entry Registration Wizard",
    "new_rider": "New Rider",
    "next_button": "Next >",
    "no_label": "No",
    "no_thanks": "No Thanks >",
    "override": "Override:",
    "owners": "Owner(s)",
    "payment_amount": "Amount being paid: ",
    "payment_amount_enter": "Enter Payment Amount Below:",
    "payment_label": "Payment",
    "person_not_in_ESM": "Select a person not in my ESM account",
    "person_paying_for_entry": "Person Paying for Entry",
    "person_responsible": "Person Responsible",
    "person_responsible_required": "You must enter a Person Responsible to enter in the show",
    "person_responsible_signature_required": "You must have the Person Responsible sign to enter in the show",
    "postal_zip_code": "Zip / Postal Code",
    "prize_money_payee": "Prize Money Payee",
    "recheck_ec": "Recheck EC",
    "remove_rider": "Remove %{rider}",
    "responsible_for_show_payement": "Who is responsible to the show for payment (must be 18 or older and associated with this entry)?",
    "responsible_payer_payee_label": "Person Responsible / Payer & Payee",
    "rider_added": "Rider added at: %{time}",
    "rider_agreement": "I/WE THE RIDER, AND/OR THE PARENT OR LEGAL GUARDIAN THEREOF, IF MINOR, THE UNDERSIGNED, HAVE READ AND DO UNDERSTAND THE RIDING INSTRUCTION, INDEMNIFICATION & LIABILITY RELEASE AGREEMENT, WARNINGS, ASSUMPTION OF RISK AND VOLUNTARILY SIGN THIS AGREEMENT, AND FURTHER AGREES THAT NO ORAL REPRESENTATION, STATEMENTS, OR INDUCEMENTS APART FROM THE ABOVE WRITTEN AGREEMENT HAVE BEEN MADE BY ANY OF THE RELEASEES.",
    "rider_has_bronze_membership": "This show requires the rider has a bronze membership with Equestrian Canada.  A Temporary Rider Fee will be charged.",
    "rider_has_fei_number": "This rider has an FEI number that does not validate with FEI.  Please check the number.",
    "rider_has_gold_member_with_equestrian_canada": "This show requires the rider has a gold membership with Equestrian Canada.  A Temporary Rider Fee will be charged.",
    "rider_has_gold_member_with_upgrade_fee": "This show requires the rider has a gold membership with Equestrian Canada.  An upgrade Fee will be charged.",
    "rider_has_sliver_membership": "This show requires the rider has a silver membership with Equestrian Canada.  A Temporary Rider Fee will be charged.",
    "rider_has_sliver_membership_with_equestrian_canada": "This show requires the rider has a silver membership with Equestrian Canada.  An upgrade Fee will be charged.",
    "rider_name": "Rider: %{name}",
    "rider_to_have_ea_number": "This show requires that the rider has a %{ea} number. Please edit the rider and add it. Otherwise, you may either be charged an extra fee at the show or not allowed to participate.",
    "rider_to_have_membership": "This show requires the rider have a valid membership with USEF.  A USEF Active Membership fee of %{fee} will be charged.",
    "riders": "Rider(s)",
    "riders_classes_label": "Riders & Classes",
    "rts_label": "MyESM Real Time Show",
    "select_classes": "Select Classes",
    "select_classes_for_rider": "Select Classes for %{rider}",
    "select_classes_for_rider_horse_html": "Select Classes for rider <b>%{rider_name}</b> on horse <b>%{entry_horse}</b>",
    "select_rider_classes": "Select new rider, and then click %{select_classes} below:",
    "select_show_and_horse": "Please, select a show and a horse, and click 'Next' to create an entry",
    "show": "Show",
    "show_horse_label": "Show & Horse",
    "stall_warning": "Services can only be entered after entering in to a show.  You may enter now with the button below or click next to continue without services.",
    "stalls_services_label": "Stalls & Services",
    "telephone": "Telephone:",
    "trainer_or_coach": "Trainer/Coach:",
    "usef_name": "USEF Name:",
    "usef_verified": "USEF Verified:",
    "warning_you_can_modify_your_entry": "WARNING You can not modify your entry after the Late Fee Date.",
    "who_will_ride": "Who will ride %{horse} and in which classes?",
    "yes_label": "Yes"
  },
  "years": "years",
  "you_have_errors": {
    "one": "The form contains one error",
    "other": "The form contains %{count} errors"
  }
});
I18n.translations["fr"] = I18n.extend((I18n.translations["fr"] || {}), {
  "activerecord": {
    "attributes": {
      "address": {
        "city": "Ville",
        "line1": "Adresse 1",
        "line2": "Adresse 2",
        "postal_code": "Code Postal/ZIP",
        "province": "Province/État"
      },
      "company": {
        "contact_name": "Nom du Contact",
        "create_company": "Mettre à jour Entreprise",
        "new": "Nouvelle Entreprise",
        "select_organization": "Choisissez l'Organization",
        "tax_id": "Identifiant fiscal"
      },
      "division": {
        "description": "Division Name",
        "division_fee": "Division Fee $",
        "fees_for_all_classes": "Single fee for all Classes $"
      },
      "equine_association": {
        "name": "Organisation",
        "number": "Numéro d'Adhésion"
      },
      "equine_association_fee": {
        "ec_temporary_horse_fee": "EC Temporary Horse fee",
        "ec_temporary_owner_sport_fee": "EC Temporary Owner Sport fee",
        "ec_temporary_rider_sport_fee": "EC Temporary Rider Sport fee",
        "ec_upgrade_bronze_to_gold_fee": "EC Upgrade Bronze to Gold fee",
        "ec_upgrade_bronze_to_silver_fee": "EC Upgrade Bronze to Silver fee",
        "ec_upgrade_silver_to_gold_fee": "EC Upgrade Silver to Gold fee",
        "usef_3_yr_senior_junior_active_membership": "USEF 3 Yr. Senior/Junior Active Membership",
        "usef_annual_horse_passport": "USEF Annual Horse Passport",
        "usef_competition_fee": "Prix de Compétition USEF",
        "usef_fei_horse_passport": "FEI Horse Passport",
        "usef_junior_active_membership": "USEF Junior Active Membership",
        "usef_lifetime_horse_passport": "USEF Lifetime Horse Passport",
        "usef_lifetime_membership": "USEF Lifetime Membership",
        "usef_national_horse_passport": "USEF National Horse Passport",
        "usef_national_to_fei_horse_passport_upgrade": "USEF National to FEI Horse Passport Upgrade",
        "usef_senior_active_membership": "USEF Senior Active Membership"
      },
      "horse": {
        "age": "Âge",
        "barn": "Grange",
        "blob": "Vaccination Certificate",
        "breed": "Race",
        "color": "Couleur",
        "dam": "Mère",
        "enter_valid_number": " number is not on the sanctioning body database. Please enter a valid number.",
        "first": "1er",
        "green": "Statut Novice",
        "height": "Hauteur (Mains)",
        "open": "Ouvert",
        "passport_verified": "Info du Passeport Vérifié",
        "pony_size": "Poney %{size}",
        "second": "2e",
        "sex": "Sexe",
        "sire": "Géniteur",
        "sire_dam": "La Mère du Géniteur",
        "size": "Taille",
        "thoroughbred_verified": "Pur-Sang Vérifié"
      },
      "individual_show": {
        "company_name": "Show Producer Company",
        "company_website": "Show Producer Website"
      },
      "officiations": {
        "cost": "Cost before tax $",
        "tax": "Tax $"
      },
      "services": {
        "campsite_warning": "Vous ne pouvez pas change la commande de camping quand les commandes",
        "cost": "Cost before tax $",
        "services_order": "Commande des Services",
        "stall_warning": "Vous ne pouvez pas change la commande d'étal quand les étals",
        "tax": "Impôt",
        "total_cost": "Coût Total",
        "unit_cost": "Xoût à l'Unité",
        "warning": " sont données. Pour l'aide, contacter le spectacle: "
      },
      "user": {
        "allow_emailing": "Autoriser l'envoi de courriel",
        "allow_texting": "Autoriser l'envoi de SMS",
        "company_name": "Nom de l'entreprise",
        "date_of_birth": "Date de naissance",
        "email": "Courriel",
        "first_name": "Prénom",
        "last_name": "Nom de Famille",
        "mobile": "Numéro de cellulaire",
        "new_person": "Nouvelle Personne",
        "password": "Mot de Passe",
        "password_confirmation": "Confirmation mot de passe",
        "phone": "Téléphone",
        "sponsored_by": "Sponsorisé Par: "
      }
    },
    "errors": {
      "messages": {
        "record_invalid": "Validation failed: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Cannot delete record because dependent %{record} exist",
          "has_one": "Cannot delete record because a dependent %{record} exists"
        }
      }
    }
  },
  "add": "Ajouter",
  "all": "Choisissez",
  "are_you_sure": "Êtes-vous sûr?",
  "at": "à",
  "back_button_label": "Retour",
  "button": {
    "circuit_results": "butt-circuit-results.jpg",
    "exhibitor_entries": "FrenchEntriesBlue.png",
    "exhibitor_entries_hint": "Cela vous permet de voir les inscriptions/commandes en attentes et celles qui sont déjà passés, et d’en créer de nouvelles",
    "exhibitor_horses": "FrenchHorsesGreen.png",
    "exhibitor_horses_hint": "Ceci vous permet d’ajouter, de modifier ou de supprimer un cheval que vous avez inscrit dans le spectacle",
    "exhibitor_how_to_use": "FrenchHowToUseESM.png",
    "exhibitor_myesm": "FrenchMyESMRTS.png",
    "exhibitor_people": "FrenchPeopleRed.png",
    "exhibitor_people_hint": "Ceci vous permet d’ajouter, de modifier ou de supprimer un cavalier, un propriétaire ou un entraîneur dans votre inscription du spectacle",
    "exhibitor_reports": "FrenchReportsYellow.png",
    "exhibitor_reports_hint": "Ceci vous permet de voir vos prix, points et placements dans les spectacles et circuits individuels",
    "home_new_account": "FrenchCreateAccountYellow.png",
    "home_new_account_hint": "Cliquez ici pour créer un compte CEG qui soumettra les inscriptions",
    "home_search_account": "FrenchSearchForAccountRed.png",
    "home_search_account_hint": "Cliquez ici pour cherchez si vous avez déjà un compte avec CEG",
    "home_show_results": "FrenchShowResults.png",
    "home_show_results_hint": "Use this button to show competition results",
    "home_sign_in": "FrenchSignInBlue.png",
    "home_sign_in_hint": "Connectez-vous à CEG"
  },
  "casl": {
    "text": "<h1>Formulaire de consentement de LCAP</h1> <p>COMPÉTITION ÉEQUESTRE-GESTIONNAIRE INC.<p> <p>CONSENTEMENT AUX MESSAGES ÉLECTRONIQUES COMMERCIAUX</p> <p>La Loi canadienne anti-pourriel (LCAP) exige que nous ayons votre consentement avant de vous envoyer des communications sur les événements équestres et nos services.<p> <p>Compétition Équestre-Gestionnaire fournit les services à jour dont les cavaliers ont besoin lors de toutes sortes d'événements équestres. L'accès aux statistiques des spectacles, aux résultats et aux prix, aux événements et aux spectacles à venir, ainsi qu'aux informations sur les produits et services susceptibles d'intéresser les cavaliers, sont disponibles sur nos sites Web à www.esm.horse et www.myesm.horse. Recherchez simplement les événements qui vous intéressent pour obtenir des informations complètes.</p>\n"
  },
  "class": "Classe",
  "comments": "Remarques",
  "company_label": "Entreprise",
  "company_name": "Nom de l'Entreprise",
  "currency_symbol": "$",
  "date": {
    "abbr_day_names": [
      "dim",
      "lun",
      "mar",
      "mer",
      "jeu",
      "ven",
      "sam"
    ],
    "abbr_month_names": [
      null,
      "jan.",
      "fév.",
      "mar.",
      "avr.",
      "mai",
      "juin",
      "juil.",
      "août",
      "sept.",
      "oct.",
      "nov.",
      "déc."
    ],
    "day_names": [
      "dimanche",
      "lundi",
      "mardi",
      "mercredi",
      "jeudi",
      "vendredi",
      "samedi"
    ],
    "formats": {
      "default": "%Y-%m-%d",
      "long": "%d %B %Y",
      "short": "%y-%m-%d"
    },
    "month_names": [
      null,
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre"
    ],
    "order": [
      "year",
      "month",
      "day"
    ],
    "time": {
      "am": "am",
      "formats": {
        "default": "%d %B %Y %H h %M min %S s",
        "long": "%A %d %B %Y %H h %M",
        "short": "%d %b %H h %M"
      },
      "pm": "pm"
    }
  },
  "date_placeholder": "aaaa-mm-jj",
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "about 1 hour",
        "other": "about %{count} hours"
      },
      "about_x_months": {
        "one": "about 1 month",
        "other": "about %{count} months"
      },
      "about_x_years": {
        "one": "about 1 year",
        "other": "about %{count} years"
      },
      "almost_x_years": {
        "one": "almost 1 year",
        "other": "almost %{count} years"
      },
      "half_a_minute": "half a minute",
      "less_than_x_minutes": {
        "one": "less than a minute",
        "other": "less than %{count} minutes"
      },
      "less_than_x_seconds": {
        "one": "less than 1 second",
        "other": "less than %{count} seconds"
      },
      "over_x_years": {
        "one": "over 1 year",
        "other": "over %{count} years"
      },
      "x_days": {
        "one": "1 day",
        "other": "%{count} days"
      },
      "x_minutes": {
        "one": "1 minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "1 month",
        "other": "%{count} months"
      },
      "x_seconds": {
        "one": "1 second",
        "other": "%{count} seconds"
      }
    },
    "prompts": {
      "day": "Day",
      "hour": "Hour",
      "minute": "Minute",
      "month": "Month",
      "second": "Seconds",
      "year": "Year"
    }
  },
  "delete_button_label": "Supprimer",
  "devise": {
    "confirmations": {
      "confirmed": "Votre compte a été validé.",
      "send_instructions": "Vous allez recevoir les instructions nécessaires à la confirmation de votre compte dans quelques minutes.",
      "send_paranoid_instructions": "Si votre e-mail existe dans notre base de données, vous allez bientôt recevoir un e-mail contenant les instructions de confirmation de votre compte."
    },
    "failure": {
      "already_authenticated": "Vous êtes déjà connecté.",
      "inactive": "Votre compte n'est pas encore activé.",
      "invalid": "Email et/ou mot de passe incorrect(s).",
      "last_attempt": "Vous avez droit à une tentative avant que votre compte ne soit verrouillé.",
      "locked": "Votre compte est verrouillé.",
      "not_found_in_database": "Email et/ou mot de passe incorrect(s).",
      "timeout": "Votre session est expirée. Veuillez vous reconnecter pour continuer.",
      "unauthenticated": "Vous devez vous connecter ou vous inscrire pour continuer.",
      "unconfirmed": "Vous devez valider votre compte pour continuer."
    },
    "mailer": {
      "confirmation_instructions": {
        "subject": "Instructions de confirmation"
      },
      "email_changed": {
        "subject": "Votre adresse e-mail a été modifiée avec succès"
      },
      "password_change": {
        "subject": "Votre mot de passe a été modifié avec succès"
      },
      "reset_password_instructions": {
        "subject": "Instructions pour changer le mot de passe"
      },
      "unlock_instructions": {
        "subject": "Instructions pour déverrouiller le compte"
      }
    },
    "omniauth_callbacks": {
      "failure": "Nous n'avons pas pu vous authentifier via %{kind} : '%{reason}'.",
      "success": "Authentifié avec succès via %{kind}."
    },
    "passwords": {
      "no_token": "Vous ne pouvez accéder à cette page sans passer par un e-mail de réinitialisation de mot de passe. Si vous êtes passé par un e-mail de ce type, assurez-vous d'utiliser l'URL complète.",
      "send_instructions": "Vous allez recevoir les instructions de réinitialisation du mot de passe dans quelques instants.",
      "send_paranoid_instructions": "Si votre e-mail existe dans notre base de données, vous allez recevoir un lien de réinitialisation par e-mail.",
      "updated": "Votre mot de passe a été édité avec succès, vous êtes maintenant connecté.",
      "updated_not_active": "Votre mot de passe a été changé avec succès."
    },
    "registrations": {
      "destroyed": "Votre compte a été supprimé avec succès. Nous espérons vous revoir bientôt.",
      "signed_up": "Bienvenue, vous êtes connecté.",
      "signed_up_but_inactive": "Vous êtes bien enregistré. Vous ne pouvez cependant pas vous connecter car votre compte n'est pas encore activé.",
      "signed_up_but_locked": "Vous êtes bien enregistré. Vous ne pouvez cependant pas vous connecter car votre compte est verrouillé.",
      "signed_up_but_unconfirmed": "Un message contenant un lien de confirmation a été envoyé à votre adresse email. Ouvrez ce lien pour activer votre compte.",
      "update_needs_confirmation": "Votre compte a bien été mis à jour mais nous devons vérifier votre nouvelle adresse email. Merci de vérifier vos emails et de cliquer sur le lien de confirmation pour finaliser la validation de votre nouvelle adresse.",
      "updated": "Votre compte a été modifié avec succès.",
      "updated_but_not_signed_in": "Votre compte a été modifié avec succès. Merci de vous reconnecter."
    },
    "sessions": {
      "already_signed_out": "Déconnecté.",
      "signed_in": "Connecté.",
      "signed_out": "Déconnecté."
    },
    "unlocks": {
      "send_instructions": "Vous allez recevoir les instructions nécessaires au déverrouillage de votre compte dans quelques instants.",
      "send_paranoid_instructions": "Si votre compte existe, vous allez bientôt recevoir un email contenant les instructions pour le déverrouiller.",
      "unlocked": "Votre compte a été déverrouillé avec succès, vous êtes maintenant connecté."
    }
  },
  "edit_button_label": "Modifier",
  "email": "Courriel",
  "entry": {
    "age_with_colon": "Âge:",
    "create_new_horse_entry": "Créez une nouvelle inscription de cheval",
    "create_new_services_entry": "Créez une nouvelle commande des services",
    "create_season_campsite_order": "Créez une commande de camping pour la saison",
    "create_season_stall_order": "Créez une commande des Étals pour la saison",
    "enter_show": "Entrez le Spectacle",
    "entered": "S'Inscrit",
    "entries_header": "Inscriptions",
    "gold_membership": "Le propriétaire du cheval doit avoir une adhésion d'or avec Canada Équestre sauf si vous n'enregistrez pas dans une classe avec les exigences de l'association équestre. Un prix temporaire de propriétaire sera appliquer.",
    "gold_membership_upgrade_fee": "Le propriétaire du cheval doit avoir une adhésion d'or avec Canada Équestre sauf si vous n'enregistrez pas dans une classe avec les exigences de l'association équestre. Un prix temporaire de surclasse sera appliquer.",
    "green_status_with_colon": "Statut Novice:",
    "height_hands": "Hauteur (mains):",
    "horse_can_enter_only_one_show": "Un cheval ne peut pas être inscrit dans une compétition qu’une seule fois. Un cheval peut avoir plusieurs cavaliers pour chaque compétition.",
    "horse_has_invalid_fei_number": "Le numéro FEI du cheval ne valide pas avec la FEI. SVP, vérifier le numéro.",
    "horses_or_services": "Chevaux / Commandes",
    "modal_multi_back": "Retour",
    "modal_multi_header": "Sélectionnez un spectacle pour payer vos entrées sur",
    "modal_multi_paragraph": "Payer pour le spectacle:",
    "modal_multi_select": "Sélectionner",
    "multi_payment_current_show": "Spectacle en cours",
    "multi_payment_header": "Payer plusieurs entrées avec débit/crédit en ligne",
    "multi_payment_owing": "Net Dû",
    "multi_payment_pay_now": "Payez maintenant",
    "not_entered": "Ne S'Inscrit Pas",
    "owing": "Dû",
    "owner_with_colon": "Propriétaire:",
    "pay_multi_message": "Les entrées surlignées en rouge sont celles pour lesquelles vous avez indiqué que vous paierez en ligne par carte de crédit. Pour effectuer un paiement unique pour plusieurs entrées, cliquez sur le bouton Payer plusieurs entrées, puis choisissez l'émission que vous souhaitez sélectionner. Cochez les entrées que vous souhaitez payer, puis payez avec square.",
    "pay_multiple_button": "Payer plusieurs entrées",
    "payee_tax_id": "Numéro d'impôt du bénéficiaire:",
    "payee_with_colon": "Bénéficiaire:",
    "payments_pay_cr_later": "Payer crédit/débit plus tard (Payer plusieurs entrées à la fois)",
    "press_ok_for_registration": "Cliquez OK pour continuer avec l’enregistrement.",
    "refund": "Remboursement",
    "save_later": "Sauvegardez pour plus tard",
    "save_new_entry": "Sauvegardez et Commencer une Nouvelle Entrée",
    "season_campsites": "Emplacements de camping du saison",
    "season_stalls": "Étals du saison",
    "services_must_ordered_seperately": "Les commandes des services doivent être faits séparément",
    "show_or_circuit": "Compétition ou Circuit",
    "size_with_colon": "Dimensions:",
    "split": "Partager",
    "square_multi_instruction_header": "Si vous voulez payer maintenant:",
    "square_multi_instruction_paragraph": "Entrez les détails de votre carte ci-dessous, puis cliquez sur le bouton bleu Payer",
    "stall_warning": "Vous ne pouvez ajouter des services (Étals inclus) à une entrée qu'une fois que vous l'avez entrer dans le spectacle. Appuyez sur Modifier à côté de l'entrée, puis passez à l'étape 5, Étals et Services. Appuyez ensuite sur Entrez le Spectacle pour pouvoir ajouter des services.",
    "start_date": "Date de Début",
    "thoroughbred": "Pur-Sang",
    "trainer_or_coach": "Entraîneur:",
    "trainer_with_colon": "Entraîneur:",
    "type_with_colon": "Type:",
    "upgrade_fee": "Le propriétaire du cheval doit avoir une adhésion d'argent avec Canada Équestre sauf si vous n'enregistrez pas dans une classe avec les exigences de l'association équestre. Un prix temporaire de surclasse sera appliquer.",
    "valid_horse_records_temp_horse": "Le cheval doit avoir un numéro d'enregistrement valide avec Canada Équestre sauf si vous n'enregistrez pas dans une classe avec les exigences de l'association équestre. Un prix temporaire du cheval sera appliquer.",
    "valid_horse_records_temp_owner": "Le propriétaire du cheval doit avoir une adhésion bronze avec Canada Équestre sauf si vous n'enregistrez pas dans une classe avec les exigences de l'association équestre. Un prix temporaire de propriétaire sera appliquer.",
    "valid_horse_records_temp_owner_fee": "Le propriétaire du cheval doit avoir une adhésion d'argent avec Canada Équestre sauf si vous n'enregistrez pas dans une classe avec les exigences de l'association équestre. Un prix temporaire de propriétaire sera appliquer."
  },
  "equine_association": {
    "add": "Ajoutez une adhésion",
    "add_title": "Ajoutez toutes les adhésions de cette personne. Ceux-ci seront automatiquement transférés dans vos inscriptions.",
    "associations": {
      "alberta": "Fédération Équestre d'Alberta",
      "british_columbia": "Conseil de Chevaux de la Colombie-Britannique",
      "cheval_quebec": "Cheval Québec",
      "island": "Conseil de Chevaux d'Île",
      "manitoba": "Conseil de Chevaux du Manitoba",
      "new_brunswick": "Fédération Équestre du Nouveau-Brunswick",
      "newfoundland": "Association Équestre de la Terre-Neuve-et-Labrador",
      "nova_scotia": "Fédération Équestre de la Nouvelle-Écosse",
      "ontario_equestrian": "Équestre d'Ontario",
      "ontario_hunter": "Association de Chasseur et Sauteur d'Ontario",
      "saskatchewan": "Fédération Équestre de la Saskatchewan",
      "trillium": "Association de Chasseur et Sauteur de Trillium",
      "yukon": "Association Équestre du Yukon"
    },
    "ec": "Canada Équestre",
    "error_name_number": "Combinaison de numéro de nom déjà utilisée",
    "fei": "Fédération Équestre Internationale",
    "foreign": "Étranger",
    "header": "Adhésions de l'association équine",
    "remove": "Supprimer l'adhésion",
    "select": "Choisissez l'Organisation",
    "thoroughbred_incentive": "Programme Incitative du Pur-Sang",
    "usef": "Fédération Équestre des États-Unis",
    "ushja": "Fédération de Chasseur et Sauteur des États-Unis"
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "must be accepted",
      "already_confirmed": "a déjà été validé(e), veuillez essayer de vous connecter",
      "blank": "can't be blank",
      "confirmation": "doesn't match %{attribute}",
      "confirmation_period_expired": "à confirmer dans les %{period}, merci de faire une nouvelle demande",
      "empty": "can't be empty",
      "equal_to": "must be equal to %{count}",
      "even": "must be even",
      "exclusion": "is reserved",
      "expired": "a expiré, merci d'en faire une nouvelle demande",
      "greater_than": "must be greater than %{count}",
      "greater_than_or_equal_to": "must be greater than or equal to %{count}",
      "improbable_phone": "est un numéro invalide",
      "in": "must be in %{count}",
      "inclusion": "is not included in the list",
      "invalid": "is invalid",
      "less_than": "must be less than %{count}",
      "less_than_or_equal_to": "must be less than or equal to %{count}",
      "model_invalid": "Validation failed: %{errors}",
      "not_a_number": "is not a number",
      "not_an_integer": "must be an integer",
      "not_found": "n'a pas été trouvé(e)",
      "not_locked": "n'était pas verrouillé(e)",
      "not_saved": {
        "one": "1 erreur a empêché ce(tte) %{resource} d'être sauvegardé(e) :",
        "other": "%{count} erreurs ont empêché ce(tte) %{resource} d'être sauvegardé(e) :"
      },
      "odd": "must be odd",
      "other_than": "must be other than %{count}",
      "password_too_long": "is too long",
      "present": "must be blank",
      "required": "must exist",
      "taken": "has already been taken",
      "too_long": {
        "one": "is too long (maximum is 1 character)",
        "other": "is too long (maximum is %{count} characters)"
      },
      "too_short": {
        "one": "is too short (minimum is 1 character)",
        "other": "is too short (minimum is %{count} characters)"
      },
      "wrong_length": {
        "one": "is the wrong length (should be 1 character)",
        "other": "is the wrong length (should be %{count} characters)"
      }
    }
  },
  "esm": "CEG",
  "esm_class_registration": {
    "class_needs_bronze_membership": "Le cavalier doit avoir une adhésion bronze avec Canada Équestre sauf si vous n'nregistrez pas dans une classe avec les exigences de l'association équestre. Un prix temporaire de cavalier sera appliquer.",
    "class_needs_gold_member_with_equestrian_canada": "Le cavalier doit avoir une adhésion d'or avec Canada Équestre sauf si vous n'nregistrez pas dans une classe avec les exigences de l'association équestre. Un prix temporaire de cavalier sera appliquer.",
    "class_needs_gold_member_with_upgrade_fee": "Le cavalier doit avoir une adhésion d'or avec Canada Équestre sauf si vous n'nregistrez pas dans une classe avec les exigences de l'association équestre. Un prix temporaire de surclasse sera appliquer.",
    "class_needs_sliver_membership_with_equestrian_canada": "Le cavalier doit avoir une adhésion d'argent avec Canada Équestre sauf si vous n'nregistrez pas dans une classe avec les exigences de l'association équestre. Un prix temporaire de cavalier sera appliquer.",
    "class_needs_sliver_membership_with_upgrade_fee": "Le cavalier doit avoir une adhésion d'argent avec Canada Équestre sauf si vous n'nregistrez pas dans une classe avec les exigences de l'association équestre. Un prix temporaire de surclasse sera appliquer."
  },
  "esm_help_email": "aide@ceg.horse",
  "exhibitor": {
    "activate_your_account": "Cliquez le lien pour confirmer votre compte.",
    "add_another_mobile_alert": "Ajoutez un autre numéro de portable pour les alertes",
    "advisory_message": "ATTENTION: Si vous remplacez l’adresse courriel pour ce profil, ça ne changera pas dans le système avant que vous le confirmez.",
    "casl": "LCAP",
    "casl_agree": "Je donne mon consentement à %{casl_link}",
    "casl_continue": "Vous devez donner le consentement sous LCAP pour continuer",
    "company_information_label": "Informations sur l'entreprise",
    "company_not_person": "Indice: Créez une entreprise si le cheval appartient à l'entreprise",
    "company_search": "Cherchez les entreprises",
    "company_search_hint": "Indice: Les noms partiels fonctionnent. Entrez au moins deux lettres.",
    "create_exhibitor_button": "Créer un exposant",
    "create_horse_wizard": "Créez l'Assistant d'un Cheval",
    "create_new_person_company_button_label": "Créer une nouvelle personne ou entreprise",
    "create_person_button": "Créer une nouvelle personne ou entreprise",
    "create_person_header": "Créer l'Assistant d'une personne",
    "create_person_popup_email": "Le courriel devrait être unique car ceci sera le nom d'utilisateur de la personne. Si la personne n'a pas un courriel, entrez <<nom_de_famille.prénom@esm.horse>>.",
    "create_person_popup_mobile": "Si la personne n'a pas un portable, entrez celui-ci de l'entraîneur ou parent.",
    "date_of_birth_pop": "Sélectionnez d'abord le mois et / ou l'année, puis le jour. \nCeci est utilisé pour calculer l'admissibilité au concours s'il y a des restrictions d'âge.",
    "do_not_create_dupe": "Si la personne fait partie de CEG, NE créez PAS une copie du profile; ceci causera des problèmes.",
    "ea_not_valid": "Le numéro %{ea} n'a été pas trouvé dans la base de données du corps sanctionné. SVP, entrez un numéro valide. \n",
    "ea_try_none": "Il y'avait une erreur en vérifiant le numéro d'adhésion. Voulez-vous peut-être cocher l’option RIEN?",
    "edit_exhibitor_header": "Modifier l'Exposant",
    "email_confirmed_ago": "courriel confirmé depuis %{confirmed_at}",
    "email_not_confirmed": "courriel n'est pas confirmé",
    "email_pop": "Ce courriel sera votre nom d'utilisateur pour CEG. Le courriel devrait être vérifié avant que le compte soit actif.",
    "enter": "Soumettre",
    "enter_valid_number": ": le numéro n'a été pas trouvé dans la base de données du corps sanctionné. SVP, entrez un numéro valide. \n",
    "exhibitor_home_title": "Accueil de l'Exposant",
    "exhibitor_word": "Exposant",
    "faq_22_body": "C’est possible que vous avez un compte personnel, pas un compte d'exposant. Seulement les comptes des exposants peuvent soumettre les inscriptions de chevaux, et les commandes de services pour les compétitions. Les comptes personnels existent dans les comptes des exposants, et ceux-ci ne peuvent obtenir que des rapports. Pour vérifier si vous avez un compte d'exposant, connectez-vous à CEG. Si le premier bouton de votre écran d’accueil dit Inscriptions/Commandes des services, vous avez un compte d'exposant. Si le premier bouton dit Rapports, vous avez un compte personnel.",
    "faq_22_header": "Pourquoi est-ce que je ne peux pas soumettre les inscriptions de mon compte CEG?",
    "faq_23_body": "Seulement les comptes des exposants peuvent soumettre les inscriptions et commandes des services. Les comptes des exposants contiennent aussi les profils des personnes (chaque personne qui fait partie de ce compte ait un compte personnel qui peut être utiliser pour voir les résultats, programmes entre autres choses), profils des chevaux et les enregistrements des spectacles. Pour vérifier si vous avez un compte d'exposant, connectez-vous à CEG. Si le premier bouton de votre écran d’accueil dit Inscriptions/Commandes des services, vous avez un compte d'exposant. Si le premier bouton dit Rapports, vous avez un compte personnel.",
    "faq_23_header": "Qu'est-ce que c'est la différence entre un compte d'exposant et un compte personnel?",
    "faq_24_body": "Si vous avez besoin d'aide, contactez nous: aide@ceg.horse.",
    "faq_24_header": "Quoi dois-je faire si je fais partie d'un compte d'exposant de quelqu'un d'autre, et je veux mon propre compte d'exposant pour pouvoir soumettre des inscriptions?",
    "fill_out_fields": "IMPORTANT! Vous devez compléter les champs sélectionnés avant appuyer le bouton <<Créer>>. Complétez les champs restants si vous les saviez. N'oubliez pas d'ajouter les autres adhésions que la personne possède! Voyez la liste déroulante des adhésions soutenus.",
    "final_create_notice": "Lorsque vous créez le compte, vous recevrez un courriel électronique pour valider votre adresse courriel. Cliquez sur le lien pour activer votre compte.",
    "gate_time_reminder": "Temps estimé avant mon prochain temps de barrière, envoyez un texto à:",
    "having_trouble": "Si vous avez de la difficulté avec l’utilisation de CEG, SVP contactez le secrétaire du concours ou envoyez nous un courriel.",
    "horse_search": "Cherchez pour un Cheval",
    "how_do_create_account_header": "Comment créer un compte CEG?",
    "i_want_to_create_prompt": "Je veux créer:",
    "incorrect_dob": "Vous devez entrer la date de naissance dans ce format: jj/mm/aaaa.",
    "mobile_confirmed": "Votre portable %{phone_number} est confirmé et CEG peut vous envoyer des messages de la part du secrétaire du concours.",
    "mobile_confirmed_ago": "portable confirmé il y a %{confirmed_at}",
    "mobile_empty": "SVP entrez votre numéro de portable dans le champ approprié.",
    "mobile_must_verify": "Vous devez vérifier votre numéro de portable pour que CEG puisse vous envoyer des messages de la part du secrétaire du concours.",
    "mobile_not_confirmed": "Portable n'est pas confirmé",
    "mobile_not_confirmed_with_number": "Votre numéro de portable %{phone_number} n’est pas confirmé.",
    "new_exhibtor_company": "Nouveau Exposant - Entreprise",
    "new_exhibtor_person": "Nouveau Exposant - Personne",
    "parent_guardian_contact": "S'il y a un problème avec le mineur, le spectacle contactera lees parents/tuteurs.",
    "password_match": "Les mots de passe ne correspondent pas",
    "password_pop": "Mots de passe doit contenir au moins 8 caractères",
    "people_for_header": "Personne pour %{exhibitor}",
    "people_one_only": "<strong>IMPORTANT:</strong> Une personne ne peut avoir plus qu'un profil avec CEG. Vérifiez si la personne est déjà dans le système CEG avant de créer leur nouveau profil dans votre compte. Si la personne est déjà dans le système CEG et vous leur voulez dans votre compte, veuillez demander à un secrétaire du concours hippique.",
    "people_remove": "Pour supprimer quelqu'un de votre compte, veuillez demander à un secrétaire du concours hippique.",
    "people_title": "Accueil - Personne",
    "person_already_exists": "La personne, %{person}, existe déjà dans le compte CEG de %{exhibitor}. Une personne/entreprise ne peut pas avoir plus qu’un profil dans CEG. Si vous voulez que cette personne/entreprise soit transférer dans votre compte, contactez le secrétaire du concours ou envoyez un courriel électronique à aide@ceg.horse.",
    "person_information_label": "Information de la Personne",
    "person_search": "Cherchez les Personnes",
    "person_search_hint": "Indice: Les noms partiels fonctionnent. Entrez au moins deux lettres du prénom ET nom de famille.",
    "person_search_results": {
      "enter": "Entrez",
      "this": "Ceci"
    },
    "phone_pop": "Entrez le numéro de portable de la personne.",
    "press_exhibitor_account": "Quand vous cliquez <<Créez un Exposant>>, vous recevrez un courriel pour confirmer votre adresse courriel.",
    "rts_message": "Cet outil est seulement disponible si vous avez déjà acheter MaCETR pour une entrée dans le spectacle",
    "search_before_create": "Avant de créer une nouvelle personne ou entreprise dans votre compte CEG, assurez-vous qu'elle n'est pas déjà dans le système en tapant son nom dans la case ci-dessous et en appuyant sur Rechercher.",
    "search_important_banner": "<p><b>IMPORTANT Si vous reconnaissez vos informations dans le tableau ci-dessus, mais que le courriel indiqué n’est PAS valide, contactez <a target=\"_blank\" href=\"mailto: aide@ceg.horse\">aide@ceg.horse</a> et nous changerons le courriel de votre compte pour un courriel valide.</b></p>",
    "search_not_see": "Si vous ne reconnaissez pas vos informations dans le tableau ci-dessus, appuyez sur Créer un nouveau compte CEG pour vous inscrire gratuitement à un compte CEG.",
    "search_tip_1": "Si la personne / société est déjà dans CEG, NE créez PAS de profil en double; cela posera des problèmes.",
    "search_tip_2": "Vous pouvez toujours soumettre des inscriptions en les utilisant en sélectionnant Personne ne figurant pas dans mon compte lors de la création de vos inscriptions.",
    "search_tip_3": "Si vous pensez que vous souhaitez que la personne/entreprise soit déplacée du compte exposant actuel vers votre compte, veuillez demander au secrétaire ou contactez-nous à aide@ceg.horse et nous vous aiderons.",
    "search_tip_4": "Sinon, si la personne/entreprise n'est PAS dans CEG, appuyez sur le bouton ci-dessous pour les créer.",
    "select_their_coach": "Si la personne n'est pas le cavalier, sélectionnez leur entraîneur. L'entraîneur devrait être quelqu'un enregistré avec CEG. Ils ne doivent pas faire partie de votre dossier.",
    "terms_agree": "Je suis d'accord avec le(s) %{terms_link}",
    "terms_continue": "Vous devrez être d'accord avec les Termes et Conditions pour continuer",
    "text_me_code": "Envoyez un texto de vérification",
    "they_have_memberships_prompt": "Ils ont les adhésions suivantes:",
    "this": "Ceci",
    "this_is_a": "C'est un",
    "tip_1": "Vous devrez premièrement décider si vous soumettrez  La première chose que vous devez décider lorsque vous créez un nouveau compte CEG est de savoir si vous soumettez ou non des inscriptions. Si oui, vous avez besoin d'un compte Exposant (vous devez avoir au moins 18 ans pour avoir un compte Exposant). Si non, vous avez besoin d'un compte non exposant.",
    "tip_2": "Si vous avez besoin d'un compte exposant, vous devez savoir si vous soumettez des inscriptions en tant qu'entreprise ou en tant que personne. La plupart des écuries sont des entreprises et aiment soumettre des inscriptions et payer les frais sous leur dénomination sociale. N'oubliez pas de remplir tous les champs obligatoires (ils sont marqués d'un astérisque).",
    "tip_3": "Si vous avez besoin d'un compte non exposant, vous devez demander à quelqu'un avec un compte exposant de le créer pour vous dans son compte. Si vous avez un compte exposant et que vous souhaitez créer un compte non exposant, appuyez sur Créer un compte non exposant pour obtenir des instructions étape par étape. *Remarque: un exposant peut utiliser tout non-exposant ou autre exposant dans l'ensemble du système CEG dans le cadre des inscriptions. Voir Créer des inscriptions pour plus de détails.",
    "tip_4": "Sinon, si la personne/entreprise n'est PAS dans CEG, appuyez sur le bouton ci-dessous pour les créer.",
    "trained_by_hint": "<i>Si la personne est un cavalier, sélectionnez leur entraîneur. Un entraîneur pourrait être n'importe qui dans le système CEG. L'entraîneur ne devrait pas faire partie de votre dossier. <strong>IMPORTANT! Si l'entraîneur n'est pas dans le système, vous devrez créer leur profil AVANT de créer une nouvelle personne.</strong></i>",
    "trained_by_label": "Entraîné par",
    "trainer_data": "les données de l'entraîneur sont valide",
    "type_of_account": "Type du compte",
    "update_exhibitor_button": "Sauvegardez l'exposant",
    "warning_create_one_account": "IMPORTANT: Ne créez pas plus q’un compte CEG. Cliquez <a href=\"/user_faq\">ICI</a> pour plus d’information",
    "warning_uncheck_this_box": "ATTENTION! Si vous désélectionnez cette boîte, vous ne recevrez pas des courriels concernant les spectacles où vous êtes enregistrés!",
    "you_must_be_18": "Vous DEVEZ avoir au moins 18 ans pour créer un compte"
  },
  "fees": {
    "all_riders": "Cavaliers",
    "class_fees": "Frais des Classes",
    "dressage_fee": "Prix de Dressage",
    "drug": "Médicament",
    "horse_fees": "Frais du Cheval: %{amount}",
    "horse_fees_split": "* FRAIS DU CHEVAL ET SERVICES sont divisés également entres les cavaliers.",
    "how_to_pay": "Je vais payer pour cette entrée:",
    "late_fee": "Prix d'Entrée en Retard",
    "medic": "Médecin",
    "no_pay": "Il n'y a pas un montant dû à ce temps.",
    "non_taxable": "Frais Non Imposable",
    "non_taxable_subtotal": "Sous-total Non Imposable",
    "order_summary": "Sommaire d'ordres",
    "owing": "Montant Dû: %{amount}",
    "pay_online": "Ou vous pouvez payer maintenant en ligne",
    "payments": {
      "cash": "en Espèces",
      "cheque": "Chèque payable à ",
      "debit": "Carte Bancaire en appelant ",
      "etransfer": "Virement Interac à ",
      "online": "Payer en ligne avec la carte bancaire"
    },
    "prize_money": "Prix en Argent",
    "prize_money_less": "Prix en Argent (Moins):",
    "return_show": "Retourner au Spectacle",
    "rider_fees": "Frais de Cavalier(s): %{amount}",
    "rider_share_net": "Cavaliers - Part du Net",
    "scratch_fee": "Prix de Scratch",
    "services_fees": "Frais des Services: %{amount}",
    "ship_fees": "Prix de Ship In",
    "subtotal": "Sous-total: ",
    "subtotal_after_tax": "Sous-total Après Impôts",
    "subtotal_services": "Sous-total Services:",
    "summary": "Résumé",
    "tax_number": "Numéro %{name}: %{number}",
    "taxable": "Frais Imposable",
    "taxable_subtotal": "Sous-total Imposable",
    "total": "%{item} Total(s)",
    "total_fees": "Frais Totals: %{fees}",
    "total_owing": "Montant à Payer:",
    "total_with_tax": "Total avec Impôt",
    "you_may_pay": "Vous pouvez payer comptant/part avec n'importe quel moyen de paiement noté. Pour tous les moyens de paiements, indiquez pour quel spectacle et cheval vous payerez."
  },
  "first_name": "Prénom",
  "flash": {
    "actions": {
      "create": {
        "notice": "%{resource_name} was successfully created."
      },
      "destroy": {
        "alert": "%{resource_name} could not be destroyed.",
        "notice": "%{resource_name} was successfully destroyed."
      },
      "update": {
        "notice": "%{resource_name} was successfully updated."
      }
    }
  },
  "generated_at": "Rapport généré à: ",
  "go": "Procéder",
  "help_link": "Aide",
  "helpers": {
    "select": {
      "prompt": "Please select"
    },
    "submit": {
      "create": "Create %{model}",
      "submit": "Save %{model}",
      "update": "Update %{model}"
    }
  },
  "here": "ICI",
  "home": {
    "esm": "Compétition Équestre-Gestionnaire",
    "esm_welcome1": "Bienvenue sur Compétition Équestre-Gestionnaire",
    "esm_welcome2": "Ici, vous pouvez entrer dans un concours et vérifier vos résultats.",
    "french_banner": "Nous avons de bonnes nouvelles! CEG (ESM en français)  est maintenant disponible en français! Pour utiliser le français, sélectionnez FR dans la liste déroulante dans le coin supérieur droit de l’écran. Veuillez nous excuser si vous rencontrez un peu d’anglais à l’occasion. Nous sommes encore en train de terminer les dernières parties, mais nous voulions vous remettre notre version française le plus tôt possible.",
    "learn_account_company": "Apprenez comment créer un nouveau compte de compétiteur en tant qu’entreprise %{link}",
    "learn_account_person": "Apprenez comment créer un nouveau compte de compétiteur en tant que personne %{link}",
    "not_sure_search": "Vous ne savez pas si vous avez déjà un compte CEG?",
    "sign_in": "Si vous avez un compte, connectez-vous maintenant.",
    "sign_up": "Sinon, vous pouvez vous inscrire pour un compte gratuit.",
    "trouble_contact": "Si vous avez des difficultés dans l’utilisation de CEG, SVP, contactez le secrétariat du concours ou envoyer un courriel à %{email}",
    "warning_more_accounts": "IMPORTANT: Ne créer pas plus d’un compte CEG. Pour plus d’information, cliquez sur %{link}"
  },
  "home_link": "Accueil",
  "horse": {
    "add_owner": "Ajouter un Propriétaire",
    "add_recording": "Ajouter un enregistrement",
    "add_the_horse_owners": "Ajouter les propriétaires de chevaux",
    "age_years": "Âge (ans)",
    "click_button_to_create_horse": "Sinon, si votre cheval n'est PAS en CEG, appuyez sur le bouton ci-dessous pour le créer",
    "create_horse": "Créer un cheval",
    "create_new_horse": "Créer un nouveau cheval",
    "date_of_birth_popup": "Sélectionnez d’abord le mois et/ou l’année, puis le jour.",
    "delete_vax": "Supprimer Certificat de Vaccination",
    "do_not_create_duplicate_profile": "Si votre cheval est déjà en CEG, NE créez PAS de profil en double; cela causera des problèmes.",
    "ec": "EC",
    "edit_horse": "Modifier cheval",
    "enter_valid_number": " number is not on the sanctioning body database. Please enter a valid number. \n",
    "error_label": "erreur",
    "fei": "FEI",
    "horse_already_exists": "%{horse_name} is already in ESM in the account of %{exhibitor_name}. A horse can only have one profile in ESM. If you would like this horse moved to your account, please contact any show secretary or help@esm.horse and we will help you.",
    "horse_already_in_system": "Avant de créer un nouveau cheval dans CEG, assurez-vous que votre cheval n'est pas déjà dans le système en tapant le nom de votre cheval dans la case ci-dessous et en appuyant sur Rechercher.",
    "horse_information": "Info du Cheval:",
    "horse_moved_to_current_exhibitor": "Si vous pensez que vous souhaitez que votre cheval soit déplacé du compte Exposant actuel vers votre compte, veuillez demander au secrétaire du salon à n'importe quel salon CEG ou contactez-nous à aide@ceg.horse et nous vous aiderons.",
    "horse_one_only": "<strong>IMPORTANT :</strong> un cheval ne peut avoir qu'un seul profil au sein de CEG. Avant d'essayer de créer un nouveau cheval dans votre compte, vérifiez s'il est déjà dans CEG. Si c'est le cas et que vous souhaitez qu'il soit transféré sur votre compte, veuillez envoyer un e-mail à aide@ceg.horse.",
    "horse_recording": "Numéro d’enregistrement du cheval",
    "horse_recording_numbers": "Numéros d’enregistrement des chevaux",
    "horse_remove": "Pour supprimer des chevaux de votre compte, veuillez envoyer un e-mail à aide@ceg.horse.",
    "horses_for": "Chevaux pour %{name}",
    "issuing_body": "Organisation Équestre",
    "manage_horses": "Gérer les chevaux",
    "new_horse": "Nouveau Cheval",
    "no_dob": "Il n'ya pas une date de naissance",
    "notes_about_horse": "Utilisez ce champ pour toutes les notes que vous voulez garder au sujet du cheval. Ils ne seront pas transférés à des inscriptions.",
    "number": "# du Cheval",
    "owner": "Propriétaire",
    "person_search_result": "Résultat de la recherche par personne",
    "please_select": "Veuillez sélectionner",
    "please_select_a_trainer": "S’il vous plaît, sélectionnez un entraîneur",
    "recording_numbers_for_this_horse": "Ajoutez tous les numéros d’enregistrement de cheval pour ce cheval. Ceux-ci seront automatiquement transférés à vos inscriptions.",
    "remove_owner": "Supprimer le Propriétaire",
    "remove_recording": "Supprimer le numéro d’enregistrement",
    "search_results": "Résultats de recherche",
    "sex": {
      "g": "H",
      "m": "J",
      "s": "É"
    },
    "size": {
      "l": "G",
      "m": "M",
      "s": "P"
    },
    "submit_show_entries": "Si votre cheval est déjà en CEG, NE créez PAS de profil en double ; cela causera des problèmes. Vous pouvez toujours soumettre des entrées d'exposition pour votre cheval en sélectionnant Sélectionnez un cheval qui n'est pas dans le compte lors de la création de vos entrées.",
    "this_is_the_show_name_of_the_horse": "C’est le nom de compétition du cheval",
    "this_is_used_to_determine_eligibility_for_comp": "Il sert à déterminer l’admissibilité aux compétitions.",
    "type": "Genre",
    "update_horse": "Mettre à jour Cheval",
    "upload_new_vax_cert": "Télécharger un nouveau certificat de Vacccination",
    "usef": "USEF",
    "vaccination_certificate": "Certificat de vaccination",
    "vax_expiry": "Date d'Expiration du Certificat de Vaccination",
    "verified_by": "Vérifié par %{person} le %{date}",
    "view_vax_cert": "Voir le certificat de vaccination"
  },
  "important_all_caps": "IMPORTANT",
  "invalid_date": "Date invalide (format: aaaa-mm-jj)",
  "large": "Grand",
  "last_name": "Nom de Famille",
  "loading": "Chargement en Cours...",
  "logged_in_link": "Connecté: %{user}",
  "make_payment_label": "Effectuer un Paiement",
  "mandatory_field": "* Indique un champ obligatoire",
  "medium": "Moyen",
  "mobile_number_prompt": "Numéro",
  "my_account_link": "Mon compte",
  "name": "Nom",
  "next_button_label": "Suivant",
  "next_year": "L'année prochaine",
  "none": "Aucun",
  "not_logged_in": "Pas connecté",
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%n%u",
        "negative_format": "-%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "round_mode": "default",
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "Billion",
          "million": "Million",
          "quadrillion": "Quadrillion",
          "thousand": "Thousand",
          "trillion": "Trillion",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB",
          "zb": "ZB"
        }
      }
    },
    "nth": {},
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "or": "ou",
  "pay": "Payez %{amount}$",
  "per": "par",
  "person_label": "Personne",
  "please_wait": "Attendez s'il vous plaît...",
  "prev_year": "Année précédente",
  "print": "Imprimer",
  "reports": {
    "all_classes": "Toutes les Classes",
    "all_divisions": "Toutes les Sections",
    "all_rings": "Tous les Manèges",
    "all_trainers": "Tous les Entraîneurs",
    "as_of_messge": "* montre un cavalier âgé de 18 ans ou moins à partir de 01 janvier.",
    "bracket_number": "Le nombre registré dans la classe est affiché après le nom. Le temps estimé de la classe est aussi affiché après le nombre registré.",
    "circuit_points_as_of": "Points du Circuit à partir de %{date}",
    "circuit_results_to_date": "Résultat du Circuit à ce jour",
    "circuit_results_to_date_csv": "Résultat du Circuit à ce jour (CSV)",
    "circuit_secretary_reports": "Rapports de Secrétaire du Circuit",
    "circuit_standings_as_of": "Classement du Circuit d'Entraîneurs à partir de %{date}",
    "class_name": "Nom",
    "class_number": "Classe",
    "division_class": "Programme du Section/Classe",
    "divisions": "Divisions %{division}",
    "end": "Fin",
    "entries": "Entrées",
    "entries_class": "Entrées par Classe",
    "event_name": "Épreuve",
    "facility": "Complexe: %{facility}",
    "fee_summary": "Les Prix",
    "fee_summary_csv": "Les Prix (CSV)",
    "fees_collected": "Les Prix Collectés",
    "fees_collected_csv": "Les Prix Collectés (CSV)",
    "financial_reports": "Rapports Financiers",
    "full_show_results": "Résultat du Spectacle Entier",
    "generate_pdf": "Générer Rapprt PDF",
    "get_results": "Obtenir des Résultats",
    "high_points_rider_as_of": "Points Forts du Cavalier pour Circuit à partir de %{date}",
    "high_points_rider_circuit": "Points Forts du Cavalier pour Circuit",
    "how_many_class": "Combien par Classe",
    "how_many_division_class": "Combien (par Section/Classe)",
    "no_results": "Il n'ya aucune Résultat",
    "number_entries": "# d'Entrées",
    "number_shows": "# des Spectacles Entrés",
    "numbers_completed": "Numéros Complétés: ",
    "open_csv": "Cliquez pour CSV Enregistré à %{time}",
    "open_report": "Cliquez pour Rapport Enregistré à %{time}",
    "outstanding_fees_owning_by_horse": "Solde Débiteur du Cheval",
    "outstanding_fees_owning_by_rider": "Solde Débiteur du Cavalier",
    "report_csv_not_generated": "CSV pour ce Spectacle n'est pas généré à ce Temps",
    "report_not_generated": "Rapport n'est pas généré à ce Temps",
    "report_show_not_generated": "Rapport pour ce Spectacle n'est pas généré à ce Temps",
    "reports": "Rapports",
    "reserve_champion": "Champion Réservé",
    "rider": "Cavalier",
    "ring": "Manège",
    "rts_message": "*NOTE: LE TEMPS ESTIMÉ N'EST PAS LA MÊME QUE CEG EN TEMPS RÉEL. SI CEG EN TEMPS RÉEL EST ACTIVÉ POUR CE SPECTACLE, VOUS POUVEZ VOIR LE PROGRAMME APRÈS AVOIR ACHETER MACETR.",
    "schedule_estimated": "Programme - Temps Esmtimé*",
    "scoreboard_csv": "Tableau d’Affichage (CSV)",
    "second_reserve_champion": "2e Champion Réservé",
    "select_circuit": "Choisissez Circuit",
    "select_division": "Chosissez une Section",
    "select_ring": "Choisissez Manège",
    "select_trainer": "Sélectionnez un Entraîneur",
    "select_year": "Choisissez l'Année",
    "show_and_circuit_results": "Résultats du Spectacle et des Circuits",
    "show_dates": "Dates du Spectacle: %{start} - %{end}",
    "show_entries": "Inscriptions",
    "show_results": "Résultats du Spectacle",
    "show_schedule": "Programme du spectacle",
    "show_schedules": "Programmes du Spectacle",
    "show_secretary_reports": "Rapports de Secrétaire du Spectacle",
    "sponsored": "Parrainé Par: ",
    "start": "Début",
    "start_time": "Temps de Début",
    "thoroughbred_points": "Points Forts du Pur-Sang",
    "trainer": "Entraîneur",
    "trainer_circuit_standings": "Classement du Circuit d'Entraîneurs",
    "trainer_placings": "Classement d'Entraîneurs",
    "trainer_report": "Rapport d'Entraîneur",
    "trainer_reports": "Rapports d'Entraîneur"
  },
  "rts": {
    "active_show": "Spectacles Achetés Actifs",
    "course_layout": {
      "course_layout": "Plan de Cours",
      "layout_available": "Ce plan sera disponible à %{time}",
      "no_layout": "La direction du spectacle n'a pas produit le plan encore."
    },
    "facility_map": "Plan du site",
    "ingate": "Préposés/Barrières",
    "myesm_home": "Accueil MaCEG",
    "placings": {
      "placings": "Mes Résultats"
    },
    "prizes": {
      "prizes": "Mes Prix"
    },
    "ring_schedule": {
      "ring_schedule": "Plan de Manège",
      "ring_schedule_rt": "Programme de Manège en Temps Réel",
      "select_ring": "Choisissez une Manège:"
    },
    "rts_home": "Accueil MaCETR",
    "schedule": "Horaires/Manèges",
    "services": {
      "assignments": "Assignements",
      "bedding": "Litière",
      "campsites": "Emplacements de Camping",
      "check": "Vérification du Cheval",
      "daily": "Journalier",
      "daily_campsites": "Emplacements de Camping Journaliers",
      "daily_stalls": "Étals Journaliers",
      "delivered": "Livré",
      "delivery_date": "Date de Livraison",
      "hay": "Foin",
      "new_services_entry": "Nouvelle Entrée des Services pour %{name}",
      "paddocks": "Enclos",
      "qty": "Quantité",
      "rate": "Tarif",
      "resources": {
        "bags": "sacs",
        "bales": "balles",
        "horse": "cheval/nuits",
        "paddock": "enclos/"
      },
      "services": "Mes Services",
      "show_campsites": "Emplacements de Camping du Spectacle",
      "show_duration": "Durée du Spectacle",
      "show_stalls": "Étals de Spectacle",
      "sold_out": "Tous Vendus",
      "stalls": "Étals",
      "stalls_daily": "Étals (Quotidien)",
      "stalls_show": "Étals (Spectacle)",
      "starting_from": " jour(s) à partir du "
    },
    "text_alerts": {
      "alerts": "Alertes Textos",
      "current_reminder_esm": "Rappels Actuels aux ultilisateurs de CEG",
      "current_reminder_others": "Rappels Actuels aux autres",
      "minutes_before": "Minutes Avant%{colon} ",
      "mobile": "Numéro de Téléphone",
      "recipient": "Destinataire"
    },
    "when_do_i_go": {
      "choose_class": "Choisissez une Classe:",
      "class_not_scheduled": "Classe n'est pas programmée",
      "class_start": "Date de Commencement",
      "classes": "Classes:",
      "clear_round": "Éliminer le Tour",
      "completed_type": "%{type} Complétés",
      "entry": "Numéro d'Entrée",
      "flights": "Étages",
      "jump_off": "Jump Off",
      "more_info": "Cliquez sur une classe pour obtenir plus d'info. Seulement les entrées avec MaCETR activé sont montrées.",
      "qualified_for": "Qualifié pour %{item}, (%{time})*",
      "ring_label": "Manège",
      "rounds": "Tours",
      "rt_in_gate": "In Gate en Temps Réel",
      "speed": "Vitesse",
      "trainer_rider": "Entraîneur / Propriétaire / Cavalier / Cheval",
      "type_completed": "%{type} Complété (%{time})**",
      "when_go": "Quand Je Vais?"
    },
    "when_go": "Ordres/Passages"
  },
  "rts_full": "Ma Compétition Équestre en Temps Réel",
  "save_continue": "Sauvegarder et Continuer",
  "search": "Cherchez",
  "season_stalls": {
    "amount": "Somme",
    "assignments": "Cession d'%{type}",
    "camping_notes": "Notes de Camping",
    "camping_notes_colon": "Notes de Camping: %{note}",
    "campsite": "Emplacement de Camping",
    "campsite_assignments": "Cessions des Emplacements de Camping",
    "campsite_notes": "Notes d'emplacements de Camping",
    "campsites": "Emplacements de Camping",
    "campsites_daily": "Emplacements de Camping (Quotidien)",
    "campsites_show": "Emplacements de Camping (Spectacle)",
    "correct_order": "Êtes-vous sûr que votre commande est exacte? Vous ne pouvez pas changer la commande après vous êtes donnés un %{type} spécifique. Vous deviez téléphoner pour modifier la commande.",
    "day": "Jour",
    "delete_confirm": "Supprimer la Commande d'%{type} de Saisons pour le Circuit %{circuit}?",
    "edit_order": "Les Commandes ne peuvent pas être modifier après les %{type} sont assignés. Pour l'assistance, contacter",
    "email_order": "Courriel pour la Commande d'%{type} de Saisons",
    "fee_adjustments": "Ajustement des Frais",
    "name": "Nom: %{name}",
    "payments": "Paiments",
    "phone": "Téléphone: %{phone}",
    "receipt": "Reçu",
    "save": "Sauvegarder",
    "season_order": "Commande Locative pour l'%{type} de la Saison",
    "seasonal_order": "Commande Locative pour l'%{type} Saisonal",
    "show_functions": "Fonctions des Secrétaire du Spectacle",
    "stabling": "Mettre à L'écurie",
    "stabling_notes": "Notes pour Mettre à L'écurie",
    "stabling_notes_colon": "Notes pour Mettre à L'écurie: %{note}",
    "stall": "Étal",
    "stalls": "Étals",
    "submit_order": "Soumettre Commande",
    "telephone_order": "Téléphone pour la Commande d'%{type} de Saisons",
    "type": "Type d'%{type}",
    "unassigned": "Non Assigné"
  },
  "select_date": "Sélectionnez une Date",
  "service_entry": {
    "no_services_available": "There are no services availalbe for this show"
  },
  "show": {
    "create_new_show_page_header": "Créer un nouveau concours (Étape 1)",
    "create_new_show_title": " Créer un nouveau concours",
    "create_show_button_label": "Créer un concours",
    "select_facility_label": "Sélectionnez un établissement",
    "select_facility_prompt": "Choisissez un profil d’établissement",
    "select_show_label": "Sélectionnez une Spectacle",
    "select_show_template_label": "Sélectionnez un modèle de concours",
    "select_show_template_prompt": "Choisissez un modèle de concours",
    "start_date_hint": "Sélectionnez le mois et/ou l’année, \npuis la journée."
  },
  "sign_in": "Connexion",
  "sign_in_page": {
    "email": "Courriel",
    "forgot_password": "Avez-vous oublié votre Mot de Passe?",
    "no_confirmation": "Vous n'avez pas reçu d'instructions de confirmation?",
    "password": "Mot de Passe",
    "remember_me": "Se souvenir de moi",
    "resend_instructions": "Me r'envoyez les Instructions pour Confirmation",
    "reset_pass_instructions": "M'envoyez les instructions pour réinitialiser mon Mot de Passe"
  },
  "sign_out": "Déconnexion",
  "sign_up": "Inscrivez-vous",
  "simple_form": {
    "error_notification": {
      "default_message": "Veuillez examiner les problèmes ci-dessous:"
    },
    "hints": {
      "registrant": {
        "allow_emailing": "WARNING! If you uncheck this box you will no longer receive important emails from shows where you are entered!",
        "allow_texting": "WARNING! If you uncheck this box you will no longer receive important text messages from shows where you are entered!"
      },
      "user": {
        "allow_emailing": "ATTENTION! Si vous décochez cette case, vous ne recevrez plus des courriels importants des compétitions auxquelles vous êtes inscrit!",
        "allow_texting": "ATTENTION! Si vous décochez cette case, vous ne recevrez plus de SMS importants des compétitions auxquelles vous êtes inscrit!"
      }
    },
    "labels": {
      "esm_class": {
        "estimated_changeover_time": "Estimated changeover time in minutes before the class can be started",
        "estimated_time_for_class": "Estimated time for class (minutes)",
        "estimated_time_per_rider": "Estimated time per rider (minutes)",
        "estimated_time_per_rider_for_jump_off": "Estimated time per rider for jump off (minutes)",
        "estimated_time_per_rider_for_power": "Estimated time per rider for Power (minutes)",
        "estimated_time_per_rider_for_qualification": "Estimated time per rider for jump off qualification (minutes)",
        "estimated_time_per_rider_for_speed": "Estimated time per rider for Speed (minutes)",
        "ribbon_award_time": "Ribbon Award Time"
      },
      "individual_show": {
        "default_ribbon_award_time": "Default Ribbon Award Time"
      },
      "registrant": {
        "company_name": "Company Name",
        "contact_name": "Contact Name",
        "tax_number": "Tax ID"
      },
      "user": {
        "company_name": "Nom de l'entreprise",
        "contact_name": "Nom du contact",
        "tax_number": "Identifiant fiscal"
      }
    },
    "no": "Non",
    "required": {
      "mark": "*",
      "text": "obligatoire"
    },
    "yes": "Oui"
  },
  "small": "Petit",
  "support": {
    "array": {
      "last_word_connector": ", and ",
      "two_words_connector": " and ",
      "words_connector": ", "
    }
  },
  "terms_link": "Termes et conditions",
  "time": {
    "am": "am",
    "formats": {
      "default": "%a, %d %b %Y %H:%M:%S %z",
      "long": "%B %d, %Y %H:%M",
      "short": "%d %b %H:%M"
    },
    "pm": "pm"
  },
  "time_not_set": "l'heure n'est pas fixée",
  "user": {
    "account_search": "Cherchez pour le Compte",
    "add_another_guardian": "Ajouter un autre contact parent/tuteur",
    "company_name_account": "Nom de l'Entreprise sur le Compte",
    "create_label": "Créer",
    "create_person_label": "Créer une personne",
    "duplicate": "Si vous avez déjà un compte CEG, SVP ne créez pas un copie du compte. Cela causera des problèmes.",
    "edit_person_and_company": "Modifier la personne / entreprise",
    "edit_profile": "Modifiez Profil",
    "email_hidden": "Code Postal / Courriel sont cachés partiellement pour les raisons d'intimités",
    "faq": {
      "account_merged_moved_body": "Chaque personne peut seulement avoir un compte CEG pour que vous pouvez voir toutes vos activités dans une place. Si vous avez plusieurs comptes, CEG rejoint l'information dans tous les comptes sous un compte CEG. Vous serez envoyer un courriel électronique avec plus d'information (s'il y a une faute) dans ce cas.",
      "account_merged_moved_header": "J'ai reçu un courriel électronique que mon compte a été combiné ou changé. Pourquoi cela est-il arrivé?",
      "change_account_to_submit_body": "Vous devrez avoir au moins 18 ans, ou un compte d'Exposant pour soukmettre les inscriptions et les commandes des services. Si vous voulez changer votre compte au compte d'Exposant (pour soumettre les inscriptions), SVP contactez le secrétaire su spectacle.",
      "change_account_to_submit_header": "Je veux changer mon compte CEG pour que je puisse soumettre des inscriptions. Qu'est-ce que je fais?",
      "change_barn_trainer_body": "Les secrétaires du spectacle peuvent changer votre compte CEG. Contactez les secrétaires au bureau du spectacle.",
      "change_barn_trainer_header": "J'ai changé ma grange ou mon entraîneur. Comment peux-je changer mon compte CEG?",
      "confused_body": "Vous pouvez contacter n'importe quel secrétaire du spectacle CEG pour l'aide avec votre compte. S'ils ne peuvent pas vous aider, ils contacteront CEG, et ensemble nous vous aiderons.",
      "confused_header": "Je suis tellement perdu. Comment peux-j'avoir d'aide avec mon compte CEG?",
      "cost_new_account_body": "Les comptes des Exposants et non-Exposants sont gratuits. Vous pouvez les utiliser pour voir les résultats du spectacles/des circuits et gérer vos incriptions. Quand vous avez créez votre compte, vous avez le choix d'acheter les services supplémentaires qui vous donnent l'accès au CEG en temps réel (MaCETR), le plan du cours et les livraisons des services, tous de votre portable.",
      "cost_new_account_header": "C'est quoi le prix pour un compte CEG?",
      "create_new_account_body": "D'abord, vous devez décider si vous allez soumettre les inscriptions du spectacle. Si oui, vous devez besoin d'un compte d'Exposant (vous devez avoir au moins 18 ans pour créer un compte d'Exposant). Sinon, vous avez besoin d'un compte de non-Exposant. Si vous avez besoin d'un compte d'Exposant, vous devrez savoir si vous allez soumettre les inscriptions de la part d'une entreprise, ou de la part d'une personne. La plus part des écuries sont des entreprises, et ils aiment soumettre les inscriptions et payer les frais du spectacle sous leur nom d'entreprise. Pour plus d'informations, appuyez sur <<Créez un compte d'Exposant pour une Entreprise>> ou <<Créez un compte d'Exposant pour une personne>>. N'oubliez pas de remplir tous les champs obligatoires (marqués avec un astérisque). Si vous avez besoin d'un compte de non-Exposant, vous devrez demander quelqu'un avec un compte d'Exposant de vous créer un compte sous eux. Si vous avez un compte d'Exposant et vous voulez créer un compte de non-Exposant, appuyez sur <<Créez un compte de non-Exposant>> *Note: un Exposant peut utiliser n'importe quel Exposant/non-Exposant dans le système CEG pour les inscriptions du spectacle. Pour plus d'information, appuyez sur <<Créez les Inscriptions des Spectacles>>.",
      "create_new_account_header": "Comment peux-je créer un nouveau compte CEG?",
      "exhibitor_no_phone_body": "Si vous créez un compte non-Exposant pour quelqu'un qui n'a pas un numéro de portable, vous pouvez utiliser votre numéro, ou le numéro de leur parents. Contrairement aux adresses courriels, vous pouvez utiliser le même numéro de portable pour plusieurs comptes CEG. N'oubliez pas qu'un numéro de portable doit être vérifier séparément pour chaque compte.",
      "exhibitor_no_phone_header": "Une personne qui fait partie de mon compte d'Exposant n'a pas un numéro de portable. Qu'est-ce que je fais?",
      "exhibitor_person_difference_body": "Seulement les comptes des exposants peuvent soumettre les inscriptions et commandes des services. Les comptes des exposants contiennent aussi les profils des personnes (chaque personne qui fait partie de ce compte ait un compte personnel qui peut être utiliser pour voir les résultats, programmes entre autres choses), profils des chevaux et les enregistrements des spectacles. Pour vérifier si vous avez un compte d'exposant, connectez-vous à CEG. Si le premier bouton de votre écran d’accueil dit Inscriptions/Commandes des services, vous avez un compte d'exposant. Si le premier bouton dit Rapports, vous avez un compte personnel.",
      "exhibitor_person_difference_header": "C'est quoi la différence entre un compte d'Exposant et un compte d'une Personne?",
      "have_esm_account_body": "Si vous ne savez pas que vous avez un compte CEG, appuyez sur <<Cherchez pour un compte CEG>>, entrez l'information et CEG cherchera pour votre compte.",
      "have_esm_account_header": "Ai-j'un compte CEG?",
      "horse_moved_merged_body": "Chaque cheval peut seulement avoir un profil dans CEG pour que CEG peut suivre tous les spectacles qu'un cheval est enregistré avec et vérifier qu'il n'y a pas des erreurs avec les points du spectacle/des circuits. Si le cheval a plusieurs profils, CEG rejoint l'information dans tous les profils sous un profil. Vous serez envoyer un courriel électronique avec plus d'information (s'il y a une faute) dans ce cas.",
      "horse_moved_merged_header": "J'ai reçu un courriel électronique qu'un cheval dans mon compte a été combiné ou changé. Pourquoi cela est-il arrivé?",
      "how_submit_entry_exhibitor_body": "Un Exposant peut soumettre un inscription pour n'importe quel personne ou cheval dans le système CEG. Pour plus d'information, appuyez sur <<Comment créer une entrée pour un cheval/cavalier qui ne font pas partie de votre compte CEG>>.",
      "how_submit_entry_exhibitor_header": "J'ai un compte d'Exposant. Comment peux-je soumettre les inscriptions des cavaliers ou chevaux qui ne font pas partie de mon compte?",
      "label": "FAQ des Comptes",
      "mobile_mandatory_body": "Un numéro de portable valide est obligatoire pour tous les comptes CEG pour que vous pouvez recevoir les informations du spectacle importants. Le même numéro peut être utiliser pour plusieurs comptes CEG. Par example, si vous êtes un entraîneur et prends des cavaliers jeunes au spectacle, et vous voulez recevoir les textos lié à leur inscriptions, vous pouvez entrer votre numéro de portable pour chaqu'un de leur comptes. Si vous faites cela, vous devriez vérifier votre numéro pour chaque compte séparément.",
      "mobile_mandatory_header": "Pourquoi est-le champ de numéro de portable obligatoire?",
      "multiple_accounts_one_number_body": "Oui! Le même numéro de portable peut ëtre utiliser pour plusieurs comptes CEG. Par example, c'est le cas quand un entraîneur est responsable pour plusieurs cavaliers jeunes, et il veut recevoir les textos lié à leur inscriptions. **Important** Si vous utiliser le même numéro pour plusieurs comptes, vous devriez vérifier votre numéro pour chaque compte séparément. Pour voir comment vérifier un numéro de portable, appuyez sur <<Comment Vérifier un Numéro de Portable>>",
      "multiple_accounts_one_number_header": "Peut-un numéro de portable être utilisé pour plusieurs comptes CEG?",
      "multiple_people_one_email_body": "Non. Chaque compte CEG devrait avoir une adresse courriel unique et vérifiée. L'adresse courriel est comment CEG identifie toutes les personnes.",
      "multiple_people_one_email_header": "Peut-une adresse courriel être utilisé pour les comptes des plusieurs personnes?",
      "new_person_no_email_body": "Vous pouvez créer un compte Gmail gratuit <a href='https://accounts.google.com/signup/v2/webcreateaccount?flowName=GlifWebSignIn&flowEntry=SignUp&hl=fr-CA'>ICI</a>. Ensuite vous devez vérifier votre adresse courriel pour utiliser votre compte CEG. Si vous utilisez le compte pour un compte non-Exposant, vous pouvez vérifier l'adresse courriel de leur part. ***Important*** Si vous êtes un Exposant qui crée un compte non-Exposant pour quelqu'un d'autre, n'oubliez pas de leur donner les détails du compte CEG pour qu'ils puissent se connecter.",
      "new_person_no_email_header": "Je veux créer un profil pour une nouvelle personne dans mon compte. Ils sont jeunes et n'ont pas des adresses courriels. Qu'est-ce que je fais?",
      "not_able_to_submit_entries_body": "C’est possible que vous avez un compte personnel, pas un compte d'exposant. Seulement les comptes des exposants peuvent soumettre les inscriptions de chevaux, et les commandes de services pour les compétitions. Les comptes personnels existent dans les comptes des exposants, et ceux-ci ne peuvent obtenir que des rapports. Pour vérifier si vous avez un compte d'exposant, connectez-vous à CEG. Si le premier bouton de votre écran d’accueil dit Inscriptions/Commandes des services, vous avez un compte d'exposant. Si le premier bouton dit Rapports, vous avez un compte personnel.",
      "not_able_to_submit_entries_header": "Pourquoi est-ce que je ne peux pas soumettre les inscriptions avec mon compte CEG?",
      "one_account_body": "Un des plusieurs forts de CEG, c'est que vous pouvez suivre toutes vos activités du spectacle dans une seule place. CEG peut seulement faire tout cela si vous avez seulement UN compte. Le système CEG voit chaque compte comme une personne différente. Donc, si vous créez plusieurs comptes, comme une example, il se peut que vous ne recevrez pas le crédit pour tous les points que vous avez gagner dans plusieurs spectacles. CEG a quelques précautions pour éviter la création des plusieurs comptes, mais en fin de compte, c'est votre responsabilité. Si vous avez créer plusieurs comptes CEG, les secrétaires du spectacle peuvent vous aider. Ils sont dans le bureau du spectacle.",
      "one_account_header": "Pourquoi peux-j'avoir seulement un compte CEG?",
      "person_want_exhibitor_body": "Si vous avez besoin d'aide, contactez nous: aide@ceg.horse.",
      "person_want_exhibitor_header": "Qu'est-ce que je fais si je fais partie d'un compte d'Exposant de quelqu'un d'autre, et je veux mon propre compte d'Exposant pour que je puisse soumettre les inscriptions?",
      "submit_entry_exhibitor_body": "Non. Tous ceux qu'ont un compte d'Exposant peuvent vous inscrire dans un spectacle, même si vous ne faites pas partie de leur compte.",
      "submit_entry_exhibitor_header": "Comme un cavalier, est-ce que seulement un Exposant peut soumettre des inscriptions?",
      "two_types_body": "Il y a deux types de comptes: l'un d'Exposant, et l'un de non-Exposant. Si vous avez un compte de non-Exposant, vous pouvez être le cavalier, le propriétaire ou l'entraîneur dans les inscriptions, vous pouvez voir les résultats du spectacle ou des circuits et vous avez l'accès à MaCETR (CEG en temps réel) sur votre portable. Un compte d'Exposant vous donnes toutes ces fonctions et le choix de 1. Soumettre les inscriptions de chval ou commandes des services pour les spectacles 2. Créer les comptes non-Exposants 3. Créer les profils des chevaux pour les inscriptions du spectacle. Vous devriez avoir au moins 18 ans pour créer un compte Exposant car les inscriptions du cheval et les commandes des services sont un contrat légal avec le spectacle.",
      "two_types_header": "C'est quoi les deux types des comptes CEG?",
      "valid_email_body": "CEG utilise votre adresse courriel pour deux choses: 1. Identifier votre compte 2. Communiquer avec les directeurs du spectacle et CEG. Tous les comptes Exposants et non-exposants doivent avoir les courriels vérifiés. Vous serez donner la chance de vérifier votre adresse courriel avant d'utiliser votre compte CEG. Si vous êtes un Exposant, et vous créez un compte non-Exposant pour quelqu'un sans une adresse courriel (ex: un enfant), vous pouvez créer un compte Gmail gratuit <a href='https://accounts.google.com/signup/v2/webcreateaccount?flowName=GlifWebSignIn&flowEntry=SignUp&hl=fr-CA'>ICI</a>. Ensuite, vous pouvez vérifier et utiliser le compte de leur part. Si vous n'avez pas une adresse courriel vérifiée, CEG ne peut pas vous contacter avec les informations importantes.",
      "valid_email_header": "Pourquoi dois-j'avoir une adresse courriel valide pour créer un compte CEG?",
      "validate_email_body": "Chaque compte d'Exposant et non-Exposant doivent avoir une adresse courriel vérifiée. Quand le compte est crée, CEG enverra un courriel qui contiendra un lien pour vérification. Pour plus d'information appuyez sur <<Comment Vérifier une adresse courriel CEG>>.",
      "validate_email_header": "Comment peux-je confirmer une adresse courriel?",
      "validate_phone_body": "Chaque compte d'Exposant et non-Exposant doivent avoir un numéro de portable. Quand le compte est crée, CEG donnera une chance pour vérifier votre numéro entré dans votre compte. Pour chaque compte, CEG a besoin d'un numéro verifié et différent, même si le numéro était utilisé pour des autres comptes. CEG n'enverra ppas des textos au compte avant que le numéro de portable est vérifié. Pour plus d'information, appuyez sur <<Comment Vérifier un Numeéro de Portable>>.",
      "validate_phone_header": "Comment peux-je confirmer un numéro de portable?"
    },
    "first_name_account": "Prénom sur le Compte",
    "last_name_account": "Nom de Famille sur le Compte",
    "parent_guardian": "Parent/Tuteur #%{number}",
    "person_not_my_account": "quequ'un d'autre...",
    "search_esm_account": "Cherchez pour mon Compte CEG",
    "send_login_info": "Envoyez l'Info",
    "send_login_info_warning": "Si vous reconnaissez votre info ci-dessous, appuyez sur <<Envoyez l'Info>> et consultez votre courriel pour comment se connecter au compte CEG.",
    "update_label": "Mettre à jour",
    "update_person_label": "Mettre à jour la personne",
    "user_search_hint": "Conseil: les noms partiels fonctionnent. Tapez au moins deux lettres du prénom ET du nom de famille.",
    "valid_cell_number": "Vous DEVEZ saisir un numéro de téléphone mobile valide, mais il n'est pas nécessaire qu'il soit unique à ce compte CEG. De plus, ce numéro doit être vérifié. Nous utiliserons ce numéro pour envoyer par SMS des informations importantes sur les inscriptions de cette personne.",
    "valid_email_address": "Cela DOIT être une courriel valide, et elle DOIT être unique à cette personne car ce sera son identifiant d'utilisateur pour se connecter à CEG. En outre, il doit être vérifié avant de pouvoir utiliser leur compte. S'ils ne possèdent pas de courriel, vous pouvez en obtenir un gratuitement à l'adresse https://www.google.com/gmail/about/. Nous utiliserons cet courriel pour envoyer des informations importantes sur les inscriptions de cette personne.",
    "warning_check_for_esm_account": "Avant que vous créez un nouveau compte CEG, SVP vérifier que vous ne déjà faites pas partie dans le système CEG. Entrez votre nom dans les boîtes ci-dessous et appuyez sur <<Cherchez>>",
    "warning_enter_two_letters": "Vous devez entrer au moins deux lettres dans la boîte pour prénom ET nom de famille, ou 2 lettres dans la boîte de l'Entreprise",
    "will_not_receive_email_warning": "ATTENTION! Si vous décochez cette case, vous ne recevrez plus des courriels importants des compétitions auxquelles vous êtes inscrit!",
    "will_not_recieve_messages_warning": "ATTENTION! Si vous décochez cette case, vous ne recevrez plus de SMS importants des compétitions auxquelles vous êtes inscrit!"
  },
  "using_ESM": {
    "create_entry_in_account": "Comment créer une entrée pour un cheval/cavalier dans votre compte CEG",
    "create_entry_not_in_account": "Comment créer une entrée pour un cheval/cavalier qui ne font pas partie de votre compte CEG",
    "create_horse_profile": "Comment créer un nouveau profil du cheval",
    "create_person": "Comment créer une nouvelle personne",
    "create_person_no_email": "Comment créer une nouvelle personne qui n'a pas un cellulaire ou courriel",
    "create_service": "Comment créer une commande des services",
    "horses": "Chevaux",
    "how_to_use": "Comment utiliser votre compte CEG",
    "intro": "Introduction à ESM",
    "overview": "Un aperçu de CEG",
    "people": "Personnes",
    "read_first": "REGARDER LES IMAGES CI-DESSOUS",
    "split_service": "Comment diviser une commande des services"
  },
  "view_button_label": "Regarder",
  "view_pay_button_label": "Voir/Payer",
  "warning": "Attention: ",
  "will_paginate": {
    "container_aria_label": "Pagination",
    "next_aria_label": "Next page",
    "next_label": "Next &#8594;",
    "page_aria_label": "Page %{page}",
    "page_entries_info": {
      "multi_page": "Displaying %{model} %{from} - %{to} of %{count} in total",
      "multi_page_html": "Displaying %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> of <b>%{count}</b> in total",
      "single_page": {
        "one": "Displaying 1 %{model}",
        "other": "Displaying all %{count} %{model}",
        "zero": "No %{model} found"
      },
      "single_page_html": {
        "one": "Displaying <b>1</b> %{model}",
        "other": "Displaying <b>all&nbsp;%{count}</b> %{model}",
        "zero": "No %{model} found"
      }
    },
    "page_gap": "&hellip;",
    "previous_aria_label": "Previous page",
    "previous_label": "&#8592; Previous"
  },
  "wizard": {
    "action": "Action",
    "add_new_person": "Ajouter une nouvelle personne",
    "add_to_entry": "Ajouter à l’inscription >",
    "address_with_colon": "Adresse:",
    "agree_to_conditions": "J'ai lu les conditions de cette inscription et j'accepte tous les termes.",
    "agree_with_signature": "Veuillez entrer votre nom et prénom",
    "agreement": "Je certifie par la présente que chaque cheval, cavalier et/ou meneur est admissible conformément au présent formulaire d'inscription et engage mes représentants et moi-même à respecter les statuts et réglements de Canada  Équestre à cette compétition. Il est par les présentes reconnu que tous les sports équestres comportent des risques inhérents et qu’aucun casque ou équipement de protection ne peut protéger contre toute éventuelle blessure. J'accepte par la présente d'assumer ce risque et je dégage Canada Équestre, le concours et ses représentants dont entre autres ses officiels, organisateurs, agents et les employés de toute responsabilité. La personne responsable (PR) accepte de communiquer tout renseignement relatif à cette inscription à Canada Équestre.",
    "all_classes_will_be_deleted": "Êtes-vous sûr? Toutes les classes inscrites seront supprimées.",
    "all_data_will_be_deleted": "Toutes les données de cette inscription seront supprimées. Êtes-vous sûr?",
    "back_button": "< Retour",
    "cancel": "Annuler",
    "change_your_search": "Si vous ne voyez pas le cheval que vous voulez, modifiez votre recherche.",
    "class_label": "Épreuve",
    "close": "Fermer",
    "coach": "Entraîneur: ",
    "confirm_the_signature": "Je comprends que la saisie électronique de mon nom constitue une signature légale et contraignante au même titre que la signature à l'encre de ma propre main.",
    "confrim_to_agreement": "En soumettant cette inscription, je confirme que je suis âgé de plus de dix-huit ans. J’accepte également d’être lié par les termes et conditions de la compétition. J’accepte également la renonciation suivante:",
    "contact_for_entry_help": "Contactez  pour de l’aide avec les inscriptions: ",
    "create_horse_in_account": "Si vous êtes certain que la recherche est correcte et que le cheval n’est pas dans la banque de données, créez-le dans votre compte",
    "create_person_in_account": "Si vous êtes certain que la recherche est correcte et que la personne n’est pas dans la banque de données, créez-la dans votre compte.",
    "data_deleted": "L'information pour ce cavalier sera supprimer. Êtes-vous sûr?",
    "date_of_birth": "Date de naissance:",
    "detail_label": "Détails",
    "division_label": "Division",
    "dont_see_person_change_your_search": "Si vous ne voyez pas la personne que vous voulez, modifiez votre recherche. ",
    "ec_name": "Nom CÉ:",
    "ec_person_responsible": "Personne responsable CÉ",
    "ec_verified": "Vérifié CÉ:",
    "edit_horse": "Modifier Cheval si Besoin",
    "edit_owner": "Modifier le propriétaire",
    "edit_rider": "Modifier le cavalier",
    "email_with_colon": "Courrier électronique: ",
    "enter_this_horse": "Inscrire ce cheval",
    "entry_for": "Entrée de %{registrant_name} dans %{individual_show}",
    "entry_show": "Entrée pour %{show}",
    "entry_submitted": "Votre entrée a été envoyée",
    "exbitator_warrant": "Dans le cas où la personne responsable CÉ indiquée dans cette entrée n’est pas la même personne qui soumet cette entrée, cette dernière garantit qu’elle a le pouvoir de lier la personne responsable CÉ indiquée.",
    "exhibitor_account": "Compte du participant",
    "exhibitor_label": "Exposant",
    "exhibitor_name": "Exposant: %{name}",
    "fee_label": "Prix",
    "fees_label": "Frais",
    "fei_name": "Nom FEI:",
    "fei_verified": "Vérifier FEI:",
    "finish_and_start_new_entry": "Terminer et commencer une nouvelle entrée",
    "finish_button": "Terminer",
    "gather_info_for_possible_tracing": "Nous sommes tenus de recueillir des renseignements pour la recherche de contacts possibles, en lien avec les mesures sanitaires. Veuillez indiquer ci-dessous les nom, courriel et le numéro de téléphone de toutes les personnes qui vous accompagneront à la compétition et qui sont associées à cette inscription (autres que les cavaliers de cette inscription).",
    "general_show_information": "Afficher les informations générales pour: %{name}",
    "horse": "Cheval",
    "horse_colon": "Cheval: %{horse}",
    "horse_name": "Nom du cheval",
    "horse_not_in_esm": "Sélectionnez un cheval qui n'est pas dans le compte CEG",
    "horses_meet_requirements": "Je certifie par la présente que chaque cheval inscrit sur ce formulaire d’inscription répond aux exigences de l’article A519, Vaccinations. Voir le Règlement de Canada Équestre, section A, Règlements généraux, article A519, Vaccins.",
    "how_will_pay": "Veuillez indiquer comment vous avez l'intention de payer pour cette entrée",
    "in_the_event": "Dans le cas où un compétiteur inscrit  participe à une compétition sanctionnée par Équestre Canada où un casque de protection est requis pour les juniors, il/elle portera un casque approuvé correctement ajusté et attaché en tout temps lorsqu’il ou elle roule sur le site de l’événement. Il est entendu que les juniors qui ne satisfont pas à cette exigence ne seront pas autorisés à participer à ces compétitions.",
    "late_entry_date": "Date d’inscription tardive: ",
    "late_entry_fee": "Frais d’inscription tardif: ",
    "late_fee_warning": "La date d’inscription tardive a déjà passé. Les entrées ne peuvent pas être changées par les participants a ce temps. Vous pouvez ajouter des classes à la 'In Gate'. Pour plus d'aide, s'il vous plaît, contacter le spectacle: %{email}.",
    "lookout_for_next_show": "Cette compétition n’est pas compatible avec MyESM. Surveillez-le lors de la prochaine compétition!",
    "mobile_hashtag": "Numéro de cellulaire",
    "mobile_with_colon": "Numéro de cellulaire:",
    "name_label_colon": "Nom:",
    "new_entry_registration_name": "Nouvelle Entrée pour %{name}",
    "new_entry_registration_wizard": "Assistant d’enregistrement des nouvelles inscriptions",
    "new_rider": "Nouveau Cavalier",
    "next_button": "Prochain >",
    "no_label": "Non",
    "no_thanks": "Non merci >",
    "override": "Annuler:",
    "owners": "Propriétaire(s)",
    "payment_amount": "Paiement de: ",
    "payment_amount_enter": "Inscrivez paiement ci-dessous:",
    "payment_label": "Paiement",
    "person_not_in_ESM": "Sélectionnez quelqu'un qui ne fait pas partie de MaCEG",
    "person_paying_for_entry": "Personne qui paie pour l’inscription",
    "person_responsible": "Personne Responsable",
    "person_responsible_required": "Vous devez entrer une personne responsable pour entrer dans le spectacle",
    "person_responsible_signature_required": "Vous devez signer le Personne responsable pour participer au spectacle",
    "postal_zip_code": "Code postal",
    "prize_money_payee": "Bénéficiaire des prix en argent",
    "recheck_ec": "Revérifier CÉ",
    "remove_rider": "Destituer %{rider}",
    "responsible_for_show_payement": "Qui est responsable du paiement de la compétition (doit avoir 18 ans ou plus et doit être associé à cette inscription)?",
    "responsible_payer_payee_label": "Personne Responsable / Payeur et Bénéficiaire",
    "rider_added": "Cavalier s'inscrit à: %{time}",
    "rider_agreement": "ON/JE LE CAVALIER, ET/OU LE PARENT OU TUTEUR, SI MINEUR, LE SOUSSIGNÉ, A/‘AI LUT/LUS ET COMPRIT/COMPRIS LES INSTRUCTIONS D’ÉQUITATION, L’INDEMNISATION  ET L’ACCORD DE DÉCHARGE DE RESPONSABILITÉ, LES AVERTISSEMENTS, L’HYPOTHÈSE DE RISQUE ET VOLONTAIREMENT SIGNE CE CONTRAT, ET EST/SUIS D’ACCORD QUE LA REPRÉSENTATION ORALE, DÉCLARATIONS, OU INCITATIONS À PART DE L’ACCORD ÉCRIT AU-DESSOUS NE SONT PAS FAIT AVEC LES RENONCIATEURS.",
    "rider_has_bronze_membership": "Cette compétition exige que le cavalier ait une license sportive Bronze auprès de Canada Équestre. Des frais de cavalier temporaire seront facturés.",
    "rider_has_fei_number": "Ce cavalier a un numéro de FEI qui ne se valide pas auprès de la FEI. Veuillez vérifier ce numéro.",
    "rider_has_gold_member_with_equestrian_canada": "Cette compétition exige que le cavalier soit membre Or de Canada Équestre. Des frais de cavalier temporaire seront facturés.",
    "rider_has_gold_member_with_upgrade_fee": "Cette compétition exige que le cavalier soit membre Or de Canada Équestre. Des frais de surclassement seront facturés.",
    "rider_has_sliver_membership": "Cette compétition exige que le cavalier soit membre Argent de Canada Équestre. Des frais de cavalier temporaire seront facturés.",
    "rider_has_sliver_membership_with_equestrian_canada": "Cette compétition exige que le cavalier soit membre Argent de Canada Équestre. Des frais de surclassement seront facturés.",
    "rider_name": "Cavalier: %{name}",
    "rider_to_have_ea_number": "Cette compétition exige que le cavalier ait un numéro %{ea}. Veuillez modifier les informations du cavalier et l’ajouter. Sinon, des frais supplémentaires peuvent être facturés ou ce cavalier peut ne pas être autorisé à participer.",
    "rider_to_have_membership": "Cette compétition exige que le participant ait une carte de membre valide auprès de l’USEF. Des frais d’adhésion de l’USEF de %{fee} seront facturés.",
    "riders": "Cavalier(s)",
    "riders_classes_label": "Cavaliers et Classes",
    "rts_label": "Spectacle en Temps Réel MaCEG",
    "select_classes": "Sélectionner des épreuves",
    "select_classes_for_rider": "Sélectionnez les Épreuves pour %{rider}",
    "select_classes_for_rider_horse_html": "Sélectionnez les épreuves pour <b>%{rider_name}</b> avec le cheval <b>%{entry_horse}</b>",
    "select_rider_classes": "Sélectionnez le cavalier, et puis cliquez sur %{select_classes}:",
    "select_show_and_horse": "S’il vous plaît, sélectionnez une compétition et un cheval, et cliquez sur 'Prochain' pour créer une inscription",
    "show": "Spectacle",
    "show_horse_label": "Spectacle et Cheval",
    "stall_warning": "Les services ne peuvent être saisis qu'après avoir participé à un spectacle. Vous pouvez entrer maintenant avec le bouton ci-dessous ou cliquer sur suivant pour continuer sans services.",
    "stalls_services_label": "Étals et Services",
    "telephone": "Téléphone:",
    "trainer_or_coach": "Entraîneur:",
    "usef_name": "Nom USEF:",
    "usef_verified": "Vérifier USEF:",
    "warning_you_can_modify_your_entry": "AVERTISSEMENT Vous ne pouvez pas modifier votre inscription après la date de retard.",
    "who_will_ride": "Qui montera %{horse}, et dans quelles classes?",
    "yes_label": "Oui"
  },
  "years": "années",
  "you_have_errors": {
    "one": "Le formulaire contient une erreur",
    "other": "Le formulaire contient %{count} erreurs"
  }
});
